// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
! tailwindcss v3.4.4 | MIT License | https://tailwindcss.com
*//*
1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)
2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)
*/

*,
::before,
::after {
  box-sizing: border-box; /* 1 */
  border-width: 0; /* 2 */
  border-style: solid; /* 2 */
  border-color: #e5e7eb; /* 2 */
}

::before,
::after {
  --tw-content: '';
}

/*
1. Use a consistent sensible line-height in all browsers.
2. Prevent adjustments of font size after orientation changes in iOS.
3. Use a more readable tab size.
4. Use the user's configured \`sans\` font-family by default.
5. Use the user's configured \`sans\` font-feature-settings by default.
6. Use the user's configured \`sans\` font-variation-settings by default.
7. Disable tap highlights on iOS
*/

html,
:host {
  line-height: 1.5; /* 1 */
  -webkit-text-size-adjust: 100%; /* 2 */
  -moz-tab-size: 4; /* 3 */
  -o-tab-size: 4;
     tab-size: 4; /* 3 */
  font-family: ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; /* 4 */
  font-feature-settings: normal; /* 5 */
  font-variation-settings: normal; /* 6 */
  -webkit-tap-highlight-color: transparent; /* 7 */
}

/*
1. Remove the margin in all browsers.
2. Inherit line-height from \`html\` so users can set them as a class directly on the \`html\` element.
*/

body {
  margin: 0; /* 1 */
  line-height: inherit; /* 2 */
}

/*
1. Add the correct height in Firefox.
2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)
3. Ensure horizontal rules are visible by default.
*/

hr {
  height: 0; /* 1 */
  color: inherit; /* 2 */
  border-top-width: 1px; /* 3 */
}

/*
Add the correct text decoration in Chrome, Edge, and Safari.
*/

abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}

/*
Remove the default font size and weight for headings.
*/

h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}

/*
Reset links to optimize for opt-in styling instead of opt-out.
*/

a {
  color: inherit;
  text-decoration: inherit;
}

/*
Add the correct font weight in Edge and Safari.
*/

b,
strong {
  font-weight: bolder;
}

/*
1. Use the user's configured \`mono\` font-family by default.
2. Use the user's configured \`mono\` font-feature-settings by default.
3. Use the user's configured \`mono\` font-variation-settings by default.
4. Correct the odd \`em\` font sizing in all browsers.
*/

code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; /* 1 */
  font-feature-settings: normal; /* 2 */
  font-variation-settings: normal; /* 3 */
  font-size: 1em; /* 4 */
}

/*
Add the correct font size in all browsers.
*/

small {
  font-size: 80%;
}

/*
Prevent \`sub\` and \`sup\` elements from affecting the line height in all browsers.
*/

sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

/*
1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)
2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)
3. Remove gaps between table borders by default.
*/

table {
  text-indent: 0; /* 1 */
  border-color: inherit; /* 2 */
  border-collapse: collapse; /* 3 */
}

/*
1. Change the font styles in all browsers.
2. Remove the margin in Firefox and Safari.
3. Remove default padding in all browsers.
*/

button,
input,
optgroup,
select,
textarea {
  font-family: inherit; /* 1 */
  font-feature-settings: inherit; /* 1 */
  font-variation-settings: inherit; /* 1 */
  font-size: 100%; /* 1 */
  font-weight: inherit; /* 1 */
  line-height: inherit; /* 1 */
  letter-spacing: inherit; /* 1 */
  color: inherit; /* 1 */
  margin: 0; /* 2 */
  padding: 0; /* 3 */
}

/*
Remove the inheritance of text transform in Edge and Firefox.
*/

button,
select {
  text-transform: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Remove default button styles.
*/

button,
input:where([type='button']),
input:where([type='reset']),
input:where([type='submit']) {
  -webkit-appearance: button; /* 1 */
  background-color: transparent; /* 2 */
  background-image: none; /* 2 */
}

/*
Use the modern Firefox focus style for all focusable elements.
*/

:-moz-focusring {
  outline: auto;
}

/*
Remove the additional \`:invalid\` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)
*/

:-moz-ui-invalid {
  box-shadow: none;
}

/*
Add the correct vertical alignment in Chrome and Firefox.
*/

progress {
  vertical-align: baseline;
}

/*
Correct the cursor style of increment and decrement buttons in Safari.
*/

::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}

/*
1. Correct the odd appearance in Chrome and Safari.
2. Correct the outline style in Safari.
*/

[type='search'] {
  -webkit-appearance: textfield; /* 1 */
  outline-offset: -2px; /* 2 */
}

/*
Remove the inner padding in Chrome and Safari on macOS.
*/

::-webkit-search-decoration {
  -webkit-appearance: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Change font properties to \`inherit\` in Safari.
*/

::-webkit-file-upload-button {
  -webkit-appearance: button; /* 1 */
  font: inherit; /* 2 */
}

/*
Add the correct display in Chrome and Safari.
*/

summary {
  display: list-item;
}

/*
Removes the default spacing and border for appropriate elements.
*/

blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}

/*
Reset default styling for dialogs.
*/
dialog {
  padding: 0;
}

/*
Prevent resizing textareas horizontally by default.
*/

textarea {
  resize: vertical;
}

/*
1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)
2. Set the default placeholder color to the user's configured gray 400 color.
*/

input::-moz-placeholder, textarea::-moz-placeholder {
  opacity: 1; /* 1 */
  color: #9ca3af; /* 2 */
}

input::placeholder,
textarea::placeholder {
  opacity: 1; /* 1 */
  color: #9ca3af; /* 2 */
}

/*
Set the default cursor for buttons.
*/

button,
[role="button"] {
  cursor: pointer;
}

/*
Make sure disabled buttons don't get the pointer cursor.
*/
:disabled {
  cursor: default;
}

/*
1. Make replaced elements \`display: block\` by default. (https://github.com/mozdevs/cssremedy/issues/14)
2. Add \`vertical-align: middle\` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)
   This can trigger a poorly considered lint error in some tools but is included by design.
*/

img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; /* 1 */
  vertical-align: middle; /* 2 */
}

/*
Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)
*/

img,
video {
  max-width: 100%;
  height: auto;
}

/* Make elements with the HTML hidden attribute stay hidden by default */
[hidden] {
  display: none;
}
  html {
    font-family: 'ABCDiatype-Regular', system-ui, sans-serif;
  }

*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}

::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}
.container {
  width: 100%;
}
@media (min-width: 640px) {

  .container {
    max-width: 640px;
  }
}
@media (min-width: 768px) {

  .container {
    max-width: 768px;
  }
}
@media (min-width: 1024px) {

  .container {
    max-width: 1024px;
  }
}
@media (min-width: 1280px) {

  .container {
    max-width: 1280px;
  }
}
@media (min-width: 1536px) {

  .container {
    max-width: 1536px;
  }
}
.pointer-events-none {
  pointer-events: none !important;
}
.visible {
  visibility: visible !important;
}
.fixed {
  position: fixed !important;
}
.\\!absolute {
  position: absolute !important;
}
.absolute {
  position: absolute !important;
}
.relative {
  position: relative !important;
}
.sticky {
  position: sticky !important;
}
.inset-0 {
  inset: 0px !important;
}
.-top-1 {
  top: -0.25rem !important;
}
.-top-1\\.5 {
  top: -0.375rem !important;
}
.bottom-0 {
  bottom: 0px !important;
}
.bottom-4 {
  bottom: 1rem !important;
}
.left-auto {
  left: auto !important;
}
.right-0 {
  right: 0px !important;
}
.right-4 {
  right: 1rem !important;
}
.top-0 {
  top: 0px !important;
}
.top-1\\/2 {
  top: 50% !important;
}
.top-12 {
  top: 3rem !important;
}
.top-2 {
  top: 0.5rem !important;
}
.-z-10 {
  z-index: -10 !important;
}
.z-10 {
  z-index: 10 !important;
}
.z-40 {
  z-index: 40 !important;
}
.z-50 {
  z-index: 50 !important;
}
.col-start-1 {
  grid-column-start: 1 !important;
}
.\\!-m-px {
  margin: -1px !important;
}
.m-0 {
  margin: 0px !important;
}
.m-auto {
  margin: auto !important;
}
.my-1 {
  margin-top: 0.25rem !important;
  margin-bottom: 0.25rem !important;
}
.my-1\\.5 {
  margin-top: 0.375rem !important;
  margin-bottom: 0.375rem !important;
}
.my-4 {
  margin-top: 1rem !important;
  margin-bottom: 1rem !important;
}
.-mt-6 {
  margin-top: -1.5rem !important;
}
.mb-1 {
  margin-bottom: 0.25rem !important;
}
.mb-2 {
  margin-bottom: 0.5rem !important;
}
.mb-4 {
  margin-bottom: 1rem !important;
}
.mb-6 {
  margin-bottom: 1.5rem !important;
}
.ml-1 {
  margin-left: 0.25rem !important;
}
.ml-px {
  margin-left: 1px !important;
}
.mr-1 {
  margin-right: 0.25rem !important;
}
.mr-2 {
  margin-right: 0.5rem !important;
}
.mr-8 {
  margin-right: 2rem !important;
}
.mt-1 {
  margin-top: 0.25rem !important;
}
.mt-10 {
  margin-top: 2.5rem !important;
}
.mt-12 {
  margin-top: 3rem !important;
}
.mt-5 {
  margin-top: 1.25rem !important;
}
.mt-6 {
  margin-top: 1.5rem !important;
}
.mt-8 {
  margin-top: 2rem !important;
}
.block {
  display: block !important;
}
.inline-block {
  display: inline-block !important;
}
.inline {
  display: inline !important;
}
.flex {
  display: flex !important;
}
.inline-flex {
  display: inline-flex !important;
}
.table {
  display: table !important;
}
.grid {
  display: grid !important;
}
.hidden {
  display: none !important;
}
.\\!h-px {
  height: 1px !important;
}
.h-10 {
  height: 2.5rem !important;
}
.h-12 {
  height: 3rem !important;
}
.h-16 {
  height: 4rem !important;
}
.h-2 {
  height: 0.5rem !important;
}
.h-3 {
  height: 0.75rem !important;
}
.h-3\\.5 {
  height: 0.875rem !important;
}
.h-4 {
  height: 1rem !important;
}
.h-5 {
  height: 1.25rem !important;
}
.h-56 {
  height: 14rem !important;
}
.h-6 {
  height: 1.5rem !important;
}
.h-60 {
  height: 15rem !important;
}
.h-8 {
  height: 2rem !important;
}
.h-\\[100px\\] {
  height: 100px !important;
}
.h-\\[109px\\] {
  height: 109px !important;
}
.h-\\[180px\\] {
  height: 180px !important;
}
.h-\\[200px\\] {
  height: 200px !important;
}
.h-\\[73px\\] {
  height: 73px !important;
}
.h-full {
  height: 100% !important;
}
.h-px {
  height: 1px !important;
}
.max-h-64 {
  max-height: 16rem !important;
}
.min-h-36 {
  min-height: 9rem !important;
}
.min-h-60 {
  min-height: 15rem !important;
}
.min-h-72 {
  min-height: 18rem !important;
}
.\\!w-px {
  width: 1px !important;
}
.w-10 {
  width: 2.5rem !important;
}
.w-12 {
  width: 3rem !important;
}
.w-16 {
  width: 4rem !important;
}
.w-2 {
  width: 0.5rem !important;
}
.w-2\\/4 {
  width: 50% !important;
}
.w-3 {
  width: 0.75rem !important;
}
.w-3\\.5 {
  width: 0.875rem !important;
}
.w-3\\/4 {
  width: 75% !important;
}
.w-4 {
  width: 1rem !important;
}
.w-5 {
  width: 1.25rem !important;
}
.w-5\\/6 {
  width: 83.333333% !important;
}
.w-6 {
  width: 1.5rem !important;
}
.w-60 {
  width: 15rem !important;
}
.w-8 {
  width: 2rem !important;
}
.w-\\[14px\\] {
  width: 14px !important;
}
.w-\\[40px\\] {
  width: 40px !important;
}
.w-auto {
  width: auto !important;
}
.w-full {
  width: 100% !important;
}
.w-max {
  width: -moz-max-content !important;
  width: max-content !important;
}
.min-w-56 {
  min-width: 14rem !important;
}
.min-w-64 {
  min-width: 16rem !important;
}
.min-w-8 {
  min-width: 2rem !important;
}
.min-w-\\[14px\\] {
  min-width: 14px !important;
}
.max-w-64 {
  max-width: 16rem !important;
}
.max-w-7xl {
  max-width: 80rem !important;
}
.max-w-96 {
  max-width: 24rem !important;
}
.max-w-\\[472px\\] {
  max-width: 472px !important;
}
.max-w-\\[800px\\] {
  max-width: 800px !important;
}
.max-w-full {
  max-width: 100% !important;
}
.max-w-lg {
  max-width: 32rem !important;
}
.flex-1 {
  flex: 1 1 0% !important;
}
.shrink-0 {
  flex-shrink: 0 !important;
}
.border-spacing-x-4 {
  --tw-border-spacing-x: 1rem !important;
  border-spacing: var(--tw-border-spacing-x) var(--tw-border-spacing-y) !important;
}
.-translate-y-1\\/2 {
  --tw-translate-y: -50% !important;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}
.rotate-180 {
  --tw-rotate: 180deg !important;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}
.scale-100 {
  --tw-scale-x: 1 !important;
  --tw-scale-y: 1 !important;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}
.scale-90 {
  --tw-scale-x: .9 !important;
  --tw-scale-y: .9 !important;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}
.transform {
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}
@keyframes pulse {

  50% {
    opacity: .5;
  }
}
.animate-pulse {
  animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite !important;
}
@keyframes spin {

  to {
    transform: rotate(360deg);
  }
}
.animate-spin {
  animation: spin 1s linear infinite !important;
}
.cursor-no-drop {
  cursor: no-drop !important;
}
.cursor-not-allowed {
  cursor: not-allowed !important;
}
.cursor-pointer {
  cursor: pointer !important;
}
.appearance-none {
  -webkit-appearance: none !important;
     -moz-appearance: none !important;
          appearance: none !important;
}
.grid-cols-1 {
  grid-template-columns: repeat(1, minmax(0, 1fr)) !important;
}
.grid-cols-2 {
  grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
}
.flex-row {
  flex-direction: row !important;
}
.flex-col {
  flex-direction: column !important;
}
.flex-col-reverse {
  flex-direction: column-reverse !important;
}
.items-start {
  align-items: flex-start !important;
}
.items-center {
  align-items: center !important;
}
.justify-end {
  justify-content: flex-end !important;
}
.justify-center {
  justify-content: center !important;
}
.justify-between {
  justify-content: space-between !important;
}
.justify-items-center {
  justify-items: center !important;
}
.gap-0 {
  gap: 0px !important;
}
.gap-0\\.5 {
  gap: 0.125rem !important;
}
.gap-1 {
  gap: 0.25rem !important;
}
.gap-1\\.5 {
  gap: 0.375rem !important;
}
.gap-12 {
  gap: 3rem !important;
}
.gap-2 {
  gap: 0.5rem !important;
}
.gap-2\\.5 {
  gap: 0.625rem !important;
}
.gap-24 {
  gap: 6rem !important;
}
.gap-3 {
  gap: 0.75rem !important;
}
.gap-4 {
  gap: 1rem !important;
}
.gap-5 {
  gap: 1.25rem !important;
}
.gap-6 {
  gap: 1.5rem !important;
}
.gap-7 {
  gap: 1.75rem !important;
}
.gap-8 {
  gap: 2rem !important;
}
.gap-x-24 {
  -moz-column-gap: 6rem !important;
       column-gap: 6rem !important;
}
.gap-y-2 {
  row-gap: 0.5rem !important;
}
.gap-y-3 {
  row-gap: 0.75rem !important;
}
.space-y-4 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0 !important;
  margin-top: calc(1rem * calc(1 - var(--tw-space-y-reverse))) !important;
  margin-bottom: calc(1rem * var(--tw-space-y-reverse)) !important;
}
.self-center {
  align-self: center !important;
}
.self-stretch {
  align-self: stretch !important;
}
.overflow-auto {
  overflow: auto !important;
}
.\\!overflow-hidden {
  overflow: hidden !important;
}
.overflow-hidden {
  overflow: hidden !important;
}
.overflow-y-auto {
  overflow-y: auto !important;
}
.\\!whitespace-nowrap {
  white-space: nowrap !important;
}
.rounded {
  border-radius: 0.25rem !important;
}
.rounded-2xl {
  border-radius: 1rem !important;
}
.rounded-3xl {
  border-radius: 1.5rem !important;
}
.rounded-\\[32px\\] {
  border-radius: 32px !important;
}
.rounded-full {
  border-radius: 9999px !important;
}
.rounded-lg {
  border-radius: 0.5rem !important;
}
.rounded-xl {
  border-radius: 0.75rem !important;
}
.rounded-bl-2xl {
  border-bottom-left-radius: 1rem !important;
}
.\\!border-0 {
  border-width: 0px !important;
}
.border {
  border-width: 1px !important;
}
.border-0 {
  border-width: 0px !important;
}
.border-2 {
  border-width: 2px !important;
}
.border-4 {
  border-width: 4px !important;
}
.border-b {
  border-bottom-width: 1px !important;
}
.border-b-0 {
  border-bottom-width: 0px !important;
}
.border-t {
  border-top-width: 1px !important;
}
.border-solid {
  border-style: solid !important;
}
.border-black\\/10 {
  border-color: rgb(0 0 0 / 0.1) !important;
}
.border-current {
  border-color: currentColor !important;
}
.border-gray-200 {
  --tw-border-opacity: 1 !important;
  border-color: rgb(229 231 235 / var(--tw-border-opacity)) !important;
}
.border-gray-300 {
  --tw-border-opacity: 1 !important;
  border-color: rgb(209 213 219 / var(--tw-border-opacity)) !important;
}
.border-neutral-300 {
  --tw-border-opacity: 1 !important;
  border-color: rgb(212 212 212 / var(--tw-border-opacity)) !important;
}
.border-red-600 {
  --tw-border-opacity: 1 !important;
  border-color: rgb(220 38 38 / var(--tw-border-opacity)) !important;
}
.border-slate-700 {
  --tw-border-opacity: 1 !important;
  border-color: rgb(51 65 85 / var(--tw-border-opacity)) !important;
}
.border-smokeWhite {
  --tw-border-opacity: 1 !important;
  border-color: rgb(240 240 240 / var(--tw-border-opacity)) !important;
}
.border-transparent {
  border-color: transparent !important;
}
.border-r-transparent {
  border-right-color: transparent !important;
}
.bg-amber-500 {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(245 158 11 / var(--tw-bg-opacity)) !important;
}
.bg-black {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(0 0 0 / var(--tw-bg-opacity)) !important;
}
.bg-gray-100 {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(243 244 246 / var(--tw-bg-opacity)) !important;
}
.bg-gray-200 {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(229 231 235 / var(--tw-bg-opacity)) !important;
}
.bg-gray-300 {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(209 213 219 / var(--tw-bg-opacity)) !important;
}
.bg-green-50 {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(240 253 244 / var(--tw-bg-opacity)) !important;
}
.bg-green-600 {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(22 163 74 / var(--tw-bg-opacity)) !important;
}
.bg-neutral-950 {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(10 10 10 / var(--tw-bg-opacity)) !important;
}
.bg-offWhite {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(250 250 250 / var(--tw-bg-opacity)) !important;
}
.bg-red-600 {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(220 38 38 / var(--tw-bg-opacity)) !important;
}
.bg-slate-900 {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(15 23 42 / var(--tw-bg-opacity)) !important;
}
.bg-smokeWhite {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(240 240 240 / var(--tw-bg-opacity)) !important;
}
.bg-white {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity)) !important;
}
.bg-zinc-50 {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(250 250 250 / var(--tw-bg-opacity)) !important;
}
.bg-gradient-to-b {
  background-image: linear-gradient(to bottom, var(--tw-gradient-stops)) !important;
}
.bg-gradient-to-t {
  background-image: linear-gradient(to top, var(--tw-gradient-stops)) !important;
}
.from-gray-50 {
  --tw-gradient-from: #f9fafb var(--tw-gradient-from-position) !important;
  --tw-gradient-to: rgb(249 250 251 / 0) var(--tw-gradient-to-position) !important;
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to) !important;
}
.from-green-700 {
  --tw-gradient-from: #15803d var(--tw-gradient-from-position) !important;
  --tw-gradient-to: rgb(21 128 61 / 0) var(--tw-gradient-to-position) !important;
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to) !important;
}
.from-red-700 {
  --tw-gradient-from: #b91c1c var(--tw-gradient-from-position) !important;
  --tw-gradient-to: rgb(185 28 28 / 0) var(--tw-gradient-to-position) !important;
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to) !important;
}
.to-gray-100 {
  --tw-gradient-to: #f3f4f6 var(--tw-gradient-to-position) !important;
}
.to-green-600 {
  --tw-gradient-to: #16a34a var(--tw-gradient-to-position) !important;
}
.to-red-600 {
  --tw-gradient-to: #dc2626 var(--tw-gradient-to-position) !important;
}
.bg-auto {
  background-size: auto !important;
}
.fill-black\\/\\[\\.5\\] {
  fill: rgb(0 0 0 / .5) !important;
}
.\\!p-0 {
  padding: 0px !important;
}
.p-2 {
  padding: 0.5rem !important;
}
.p-2\\.5 {
  padding: 0.625rem !important;
}
.p-3 {
  padding: 0.75rem !important;
}
.p-4 {
  padding: 1rem !important;
}
.p-6 {
  padding: 1.5rem !important;
}
.p-8 {
  padding: 2rem !important;
}
.px-12 {
  padding-left: 3rem !important;
  padding-right: 3rem !important;
}
.px-2 {
  padding-left: 0.5rem !important;
  padding-right: 0.5rem !important;
}
.px-2\\.5 {
  padding-left: 0.625rem !important;
  padding-right: 0.625rem !important;
}
.px-3 {
  padding-left: 0.75rem !important;
  padding-right: 0.75rem !important;
}
.px-4 {
  padding-left: 1rem !important;
  padding-right: 1rem !important;
}
.px-6 {
  padding-left: 1.5rem !important;
  padding-right: 1.5rem !important;
}
.py-1 {
  padding-top: 0.25rem !important;
  padding-bottom: 0.25rem !important;
}
.py-1\\.5 {
  padding-top: 0.375rem !important;
  padding-bottom: 0.375rem !important;
}
.py-12 {
  padding-top: 3rem !important;
  padding-bottom: 3rem !important;
}
.py-2 {
  padding-top: 0.5rem !important;
  padding-bottom: 0.5rem !important;
}
.py-3 {
  padding-top: 0.75rem !important;
  padding-bottom: 0.75rem !important;
}
.py-4 {
  padding-top: 1rem !important;
  padding-bottom: 1rem !important;
}
.py-5 {
  padding-top: 1.25rem !important;
  padding-bottom: 1.25rem !important;
}
.py-8 {
  padding-top: 2rem !important;
  padding-bottom: 2rem !important;
}
.pb-5 {
  padding-bottom: 1.25rem !important;
}
.pt-2 {
  padding-top: 0.5rem !important;
}
.text-left {
  text-align: left !important;
}
.text-center {
  text-align: center !important;
}
.text-right {
  text-align: right !important;
}
.text-start {
  text-align: start !important;
}
.align-middle {
  vertical-align: middle !important;
}
.align-\\[-0\\.125em\\] {
  vertical-align: -0.125em !important;
}
.font-sans {
  font-family: ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji" !important;
}
.text-2xl {
  font-size: 1.5rem !important;
  line-height: 2rem !important;
}
.text-3xl {
  font-size: 1.875rem !important;
  line-height: 2.25rem !important;
}
.text-4xl {
  font-size: 2.25rem !important;
  line-height: 2.5rem !important;
}
.text-5xl {
  font-size: 3rem !important;
  line-height: 1 !important;
}
.text-\\[28px\\] {
  font-size: 28px !important;
}
.text-\\[32px\\] {
  font-size: 32px !important;
}
.text-base {
  font-size: 1rem !important;
  line-height: 1.5rem !important;
}
.text-lg {
  font-size: 1.125rem !important;
  line-height: 1.75rem !important;
}
.text-sm {
  font-size: 0.875rem !important;
  line-height: 1.25rem !important;
}
.text-xl {
  font-size: 1.25rem !important;
  line-height: 1.75rem !important;
}
.text-xs {
  font-size: 0.75rem !important;
  line-height: 1rem !important;
}
.font-bold {
  font-weight: 700 !important;
}
.font-extrabold {
  font-weight: 800 !important;
}
.font-medium {
  font-weight: 500 !important;
}
.font-normal {
  font-weight: 400 !important;
}
.font-semibold {
  font-weight: 600 !important;
}
.uppercase {
  text-transform: uppercase !important;
}
.leading-5 {
  line-height: 1.25rem !important;
}
.leading-normal {
  line-height: 1.5 !important;
}
.tracking-\\[2px\\] {
  letter-spacing: 2px !important;
}
.text-\\[\\#DC2626\\] {
  --tw-text-opacity: 1 !important;
  color: rgb(220 38 38 / var(--tw-text-opacity)) !important;
}
.text-black {
  --tw-text-opacity: 1 !important;
  color: rgb(0 0 0 / var(--tw-text-opacity)) !important;
}
.text-black\\/25 {
  color: rgb(0 0 0 / 0.25) !important;
}
.text-black\\/\\[\\.38\\] {
  color: rgb(0 0 0 / .38) !important;
}
.text-black\\/\\[\\.5\\] {
  color: rgb(0 0 0 / .5) !important;
}
.text-disabledGray {
  --tw-text-opacity: 1 !important;
  color: rgb(119 119 119 / var(--tw-text-opacity)) !important;
}
.text-gray-600 {
  --tw-text-opacity: 1 !important;
  color: rgb(75 85 99 / var(--tw-text-opacity)) !important;
}
.text-green-700 {
  --tw-text-opacity: 1 !important;
  color: rgb(21 128 61 / var(--tw-text-opacity)) !important;
}
.text-orange-300 {
  --tw-text-opacity: 1 !important;
  color: rgb(253 186 116 / var(--tw-text-opacity)) !important;
}
.text-quickSilver {
  --tw-text-opacity: 1 !important;
  color: rgb(161 161 161 / var(--tw-text-opacity)) !important;
}
.text-red-600 {
  --tw-text-opacity: 1 !important;
  color: rgb(220 38 38 / var(--tw-text-opacity)) !important;
}
.text-slate-50 {
  --tw-text-opacity: 1 !important;
  color: rgb(248 250 252 / var(--tw-text-opacity)) !important;
}
.text-white {
  --tw-text-opacity: 1 !important;
  color: rgb(255 255 255 / var(--tw-text-opacity)) !important;
}
.text-white\\/50 {
  color: rgb(255 255 255 / 0.5) !important;
}
.underline {
  text-decoration-line: underline !important;
}
.line-through {
  text-decoration-line: line-through !important;
}
.no-underline {
  text-decoration-line: none !important;
}
.opacity-25 {
  opacity: 0.25 !important;
}
.opacity-30 {
  opacity: 0.3 !important;
}
.opacity-35 {
  opacity: 0.35 !important;
}
.opacity-50 {
  opacity: 0.5 !important;
}
.shadow-inner {
  --tw-shadow: inset 0 2px 4px 0 rgb(0 0 0 / 0.05) !important;
  --tw-shadow-colored: inset 0 2px 4px 0 var(--tw-shadow-color) !important;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow) !important;
}
.shadow-md {
  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1) !important;
  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color) !important;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow) !important;
}
.shadow-none {
  --tw-shadow: 0 0 #0000 !important;
  --tw-shadow-colored: 0 0 #0000 !important;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow) !important;
}
.outline-none {
  outline: 2px solid transparent !important;
  outline-offset: 2px !important;
}
.outline {
  outline-style: solid !important;
}
.outline-0 {
  outline-width: 0px !important;
}
.blur {
  --tw-blur: blur(8px) !important;
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow) !important;
}
.filter {
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow) !important;
}
.transition {
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, -webkit-backdrop-filter !important;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter !important;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter, -webkit-backdrop-filter !important;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1) !important;
  transition-duration: 150ms !important;
}
.transition-all {
  transition-property: all !important;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1) !important;
  transition-duration: 150ms !important;
}
.transition-transform {
  transition-property: transform !important;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1) !important;
  transition-duration: 150ms !important;
}
.ease-out {
  transition-timing-function: cubic-bezier(0, 0, 0.2, 1) !important;
}
label {
    margin: 0 !important;
    letter-spacing: unset !important;
    font-weight: unset !important;
    color: unset !important;
    text-transform: unset !important;
    width: auto !important;
  }
button:not(.border) {
    border: 0 !important;
  }
button:hover {
    background-image: none !important;
  }
.animated-number > div {
    justify-content: flex-end !important;
  }
.claim-button,
  .claim-button:hover {
    background: linear-gradient(0deg, #0a0a0a 0%, #404040 100%) !important;
  }
.animate-button {
    transition: box-shadow 0.3s ease !important;
  }
.animate-button::before {
    content: '' !important;
    position: absolute !important;
    top: var(--y) !important;
    left: var(--x) !important;
    transform: translate(-50%, -50%) !important;
    width: 100px !important;
    height: 100px !important;
    border-radius: 50% !important;
    background-color: var(--hover-background) !important;
    filter: blur(30px) !important;
    transition: opacity 0.3s ease !important;
    pointer-events: none !important;
    opacity: 0.2 !important;
  }
body .animate-button::before {
    filter: blur(20px) !important;
  }
.animate-button:hover::before {
    opacity: 1 !important;
  }
body .animate-tier::before {
    top: 0 !important;
    left: 0 !important;
    transform: translate(var(--x), var(--y)) !important;
    opacity: 1 !important;
    transition: transform 1s ease !important;
    width: 200px !important;
    height: 200px !important;
  }
.show-html a {
    text-decoration: underline !important;
  }
.button-border {
    border: 1px solid #e5e7eb !important;
  }
.transparent-icon path {
    fill: white !important;
  }
.learn-more-modal-title {
  font-size: 1.25rem;
  line-height: 1.75rem;
  font-weight: 600;
  --tw-text-opacity: 1;
  color: rgb(0 0 0 / var(--tw-text-opacity));
}
.\\!\\[clip\\:rect\\(0\\2c 0\\2c 0\\2c 0\\)\\] {
  clip: rect(0,0,0,0) !important;
}
@font-face {
  font-family: 'ABCDiatype-Regular';
  font-display: swap;
  src: url('https://cdn.coinlist.co/fonts/ABCDiatype/ABCDiatype-Regular.woff2')
    format('woff2');
}
@font-face {
  font-family: 'ABCDiatype-Bold';
  font-display: swap;
  src: url('https://cdn.coinlist.co/fonts/ABCDiatype/ABCDiatype-Bold.woff2')
    format('woff2');
}
.animate-button {
  --hover-background: rgba(255, 255, 255, 0.2);
}
.ticker-digit {
  text-align: center;
}
.placeholder\\:text-black\\/\\[\\.38\\]::-moz-placeholder {
  color: rgb(0 0 0 / .38) !important;
}
.placeholder\\:text-black\\/\\[\\.38\\]::placeholder {
  color: rgb(0 0 0 / .38) !important;
}
.checked\\:border-0:checked {
  border-width: 0px !important;
}
.checked\\:bg-black:checked {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(0 0 0 / var(--tw-bg-opacity)) !important;
}
.hover\\:scale-\\[1\\.02\\]:hover {
  --tw-scale-x: 1.02 !important;
  --tw-scale-y: 1.02 !important;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}
.hover\\:border-neutral-400:hover {
  --tw-border-opacity: 1 !important;
  border-color: rgb(163 163 163 / var(--tw-border-opacity)) !important;
}
.hover\\:bg-black:hover {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(0 0 0 / var(--tw-bg-opacity)) !important;
}
.hover\\:bg-gray-100:hover {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(243 244 246 / var(--tw-bg-opacity)) !important;
}
.hover\\:bg-green-50:hover {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(240 253 244 / var(--tw-bg-opacity)) !important;
}
.hover\\:bg-neutral-300:hover {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(212 212 212 / var(--tw-bg-opacity)) !important;
}
.hover\\:bg-offWhite:hover {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(250 250 250 / var(--tw-bg-opacity)) !important;
}
.hover\\:bg-smokeWhite:hover {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(240 240 240 / var(--tw-bg-opacity)) !important;
}
.hover\\:text-black:hover {
  --tw-text-opacity: 1 !important;
  color: rgb(0 0 0 / var(--tw-text-opacity)) !important;
}
.hover\\:text-green-700:hover {
  --tw-text-opacity: 1 !important;
  color: rgb(21 128 61 / var(--tw-text-opacity)) !important;
}
.hover\\:text-white:hover {
  --tw-text-opacity: 1 !important;
  color: rgb(255 255 255 / var(--tw-text-opacity)) !important;
}
.hover\\:underline:hover {
  text-decoration-line: underline !important;
}
.hover\\:opacity-50:hover {
  opacity: 0.5 !important;
}
.focus\\:border-black:focus {
  --tw-border-opacity: 1 !important;
  border-color: rgb(0 0 0 / var(--tw-border-opacity)) !important;
}
.focus\\:text-black:focus {
  --tw-text-opacity: 1 !important;
  color: rgb(0 0 0 / var(--tw-text-opacity)) !important;
}
.focus\\:text-white:focus {
  --tw-text-opacity: 1 !important;
  color: rgb(255 255 255 / var(--tw-text-opacity)) !important;
}
.peer:checked ~ .peer-checked\\:block {
  display: block !important;
}
@media (prefers-reduced-motion: reduce) {

  @keyframes spin {

    to {
      transform: rotate(360deg);
    }
  }

  .motion-reduce\\:animate-\\[spin_1\\.5s_linear_infinite\\] {
    animation: spin 1.5s linear infinite !important;
  }
}
@media (min-width: 350px) {

  .min-\\[350px\\]\\:grid-cols-3 {
    grid-template-columns: repeat(3, minmax(0, 1fr)) !important;
  }
}
@media (min-width: 640px) {

  .sm\\:col-span-2 {
    grid-column: span 2 / span 2 !important;
  }

  .sm\\:block {
    display: block !important;
  }

  .sm\\:h-auto {
    height: auto !important;
  }

  .sm\\:w-130 {
    width: 35rem !important;
  }

  .sm\\:w-\\[46\\%\\] {
    width: 46% !important;
  }

  .sm\\:w-\\[525px\\] {
    width: 525px !important;
  }

  .sm\\:w-\\[90px\\] {
    width: 90px !important;
  }

  .sm\\:grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
  }

  .sm\\:grid-cols-3 {
    grid-template-columns: repeat(3, minmax(0, 1fr)) !important;
  }

  .sm\\:flex-row {
    flex-direction: row !important;
  }

  .sm\\:flex-col {
    flex-direction: column !important;
  }

  .sm\\:gap-4 {
    gap: 1rem !important;
  }

  .sm\\:rounded-3xl {
    border-radius: 1.5rem !important;
  }

  .sm\\:bg-cover {
    background-size: cover !important;
  }

  .sm\\:px-8 {
    padding-left: 2rem !important;
    padding-right: 2rem !important;
  }

  .sm\\:py-8 {
    padding-top: 2rem !important;
    padding-bottom: 2rem !important;
  }

  .sm\\:pb-7 {
    padding-bottom: 1.75rem !important;
  }

  .sm\\:pt-11 {
    padding-top: 2.75rem !important;
  }

  .sm\\:pt-6 {
    padding-top: 1.5rem !important;
  }

  .sm\\:text-left {
    text-align: left !important;
  }
}
@media (min-width: 768px) {

  .md\\:block {
    display: block !important;
  }

  .md\\:hidden {
    display: none !important;
  }

  .md\\:min-w-\\[500px\\] {
    min-width: 500px !important;
  }

  .md\\:grid-cols-3 {
    grid-template-columns: repeat(3, minmax(0, 1fr)) !important;
  }
}
@media (min-width: 1024px) {

  .lg\\:flex {
    display: flex !important;
  }

  .lg\\:hidden {
    display: none !important;
  }

  .lg\\:w-1\\/4 {
    width: 25% !important;
  }

  .lg\\:max-w-xs {
    max-width: 20rem !important;
  }

  .lg\\:grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
  }

  .lg\\:grid-cols-4 {
    grid-template-columns: repeat(4, minmax(0, 1fr)) !important;
  }

  .lg\\:flex-row {
    flex-direction: row !important;
  }

  .lg\\:justify-end {
    justify-content: flex-end !important;
  }

  .lg\\:gap-4 {
    gap: 1rem !important;
  }
}
@media (min-width: 1280px) {

  .xl\\:w-1\\/4 {
    width: 25% !important;
  }

  .xl\\:max-w-xs {
    max-width: 20rem !important;
  }

  .xl\\:flex-row {
    flex-direction: row !important;
  }
}
.ticker-view {
  height: auto;
  margin: auto;
  display: flex;
  flex-direction: row-reverse;
  overflow: hidden;
  position: relative;
}

.number-placeholder {
  visibility: hidden;
}

.ticker-column-container {
  position: relative;
}

.ticker-column {
  position: absolute;
  height: 1000%;
  bottom: 0;
}

.ticker-digit {
  width: auto;
  height: 10%;
}

.ticker-column.increase {
  animation: pulseIncrement 500ms cubic-bezier(0.4, 0, 0.6, 1) 1;
}

.ticker-column.decrease {
  animation: pulseDecrement 500ms cubic-bezier(0.4, 0, 0.6, 1) 1;
}

@keyframes pulseIncrement {
  0%, 100% { color: inherit; }
  50% { color: var(--increment-color) }
}

@keyframes pulseDecrement {
  0%, 100% { color: inherit; }
  50% { color: var(--decrement-color) }
}
`, "",{"version":3,"sources":["webpack://./node_modules/@coinlist/frontend-ui-lib/dist/style.css"],"names":[],"mappings":"AAAA;;CAEC,CAAC;;;CAGD;;AAED;;;EAGE,sBAAsB,EAAE,MAAM;EAC9B,eAAe,EAAE,MAAM;EACvB,mBAAmB,EAAE,MAAM;EAC3B,qBAAqB,EAAE,MAAM;AAC/B;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;;;;;;;;CAQC;;AAED;;EAEE,gBAAgB,EAAE,MAAM;EACxB,8BAA8B,EAAE,MAAM;EACtC,gBAAgB,EAAE,MAAM;EACxB,cAAc;KACX,WAAW,EAAE,MAAM;EACtB,+HAA+H,EAAE,MAAM;EACvI,6BAA6B,EAAE,MAAM;EACrC,+BAA+B,EAAE,MAAM;EACvC,wCAAwC,EAAE,MAAM;AAClD;;AAEA;;;CAGC;;AAED;EACE,SAAS,EAAE,MAAM;EACjB,oBAAoB,EAAE,MAAM;AAC9B;;AAEA;;;;CAIC;;AAED;EACE,SAAS,EAAE,MAAM;EACjB,cAAc,EAAE,MAAM;EACtB,qBAAqB,EAAE,MAAM;AAC/B;;AAEA;;CAEC;;AAED;EACE,yCAAyC;UACjC,iCAAiC;AAC3C;;AAEA;;CAEC;;AAED;;;;;;EAME,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;;CAEC;;AAED;EACE,cAAc;EACd,wBAAwB;AAC1B;;AAEA;;CAEC;;AAED;;EAEE,mBAAmB;AACrB;;AAEA;;;;;CAKC;;AAED;;;;EAIE,+GAA+G,EAAE,MAAM;EACvH,6BAA6B,EAAE,MAAM;EACrC,+BAA+B,EAAE,MAAM;EACvC,cAAc,EAAE,MAAM;AACxB;;AAEA;;CAEC;;AAED;EACE,cAAc;AAChB;;AAEA;;CAEC;;AAED;;EAEE,cAAc;EACd,cAAc;EACd,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;;;;CAIC;;AAED;EACE,cAAc,EAAE,MAAM;EACtB,qBAAqB,EAAE,MAAM;EAC7B,yBAAyB,EAAE,MAAM;AACnC;;AAEA;;;;CAIC;;AAED;;;;;EAKE,oBAAoB,EAAE,MAAM;EAC5B,8BAA8B,EAAE,MAAM;EACtC,gCAAgC,EAAE,MAAM;EACxC,eAAe,EAAE,MAAM;EACvB,oBAAoB,EAAE,MAAM;EAC5B,oBAAoB,EAAE,MAAM;EAC5B,uBAAuB,EAAE,MAAM;EAC/B,cAAc,EAAE,MAAM;EACtB,SAAS,EAAE,MAAM;EACjB,UAAU,EAAE,MAAM;AACpB;;AAEA;;CAEC;;AAED;;EAEE,oBAAoB;AACtB;;AAEA;;;CAGC;;AAED;;;;EAIE,0BAA0B,EAAE,MAAM;EAClC,6BAA6B,EAAE,MAAM;EACrC,sBAAsB,EAAE,MAAM;AAChC;;AAEA;;CAEC;;AAED;EACE,aAAa;AACf;;AAEA;;CAEC;;AAED;EACE,gBAAgB;AAClB;;AAEA;;CAEC;;AAED;EACE,wBAAwB;AAC1B;;AAEA;;CAEC;;AAED;;EAEE,YAAY;AACd;;AAEA;;;CAGC;;AAED;EACE,6BAA6B,EAAE,MAAM;EACrC,oBAAoB,EAAE,MAAM;AAC9B;;AAEA;;CAEC;;AAED;EACE,wBAAwB;AAC1B;;AAEA;;;CAGC;;AAED;EACE,0BAA0B,EAAE,MAAM;EAClC,aAAa,EAAE,MAAM;AACvB;;AAEA;;CAEC;;AAED;EACE,kBAAkB;AACpB;;AAEA;;CAEC;;AAED;;;;;;;;;;;;;EAaE,SAAS;AACX;;AAEA;EACE,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;;;EAGE,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;;AAEA;;CAEC;AACD;EACE,UAAU;AACZ;;AAEA;;CAEC;;AAED;EACE,gBAAgB;AAClB;;AAEA;;;CAGC;;AAED;EACE,UAAU,EAAE,MAAM;EAClB,cAAc,EAAE,MAAM;AACxB;;AAEA;;EAEE,UAAU,EAAE,MAAM;EAClB,cAAc,EAAE,MAAM;AACxB;;AAEA;;CAEC;;AAED;;EAEE,eAAe;AACjB;;AAEA;;CAEC;AACD;EACE,eAAe;AACjB;;AAEA;;;;CAIC;;AAED;;;;;;;;EAQE,cAAc,EAAE,MAAM;EACtB,sBAAsB,EAAE,MAAM;AAChC;;AAEA;;CAEC;;AAED;;EAEE,eAAe;EACf,YAAY;AACd;;AAEA,wEAAwE;AACxE;EACE,aAAa;AACf;EACE;IACE,wDAAwD;EAC1D;;AAEF;EACE,wBAAwB;EACxB,wBAAwB;EACxB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,cAAc;EACd,cAAc;EACd,eAAe;EACf,eAAe;EACf,aAAa;EACb,aAAa;EACb,kBAAkB;EAClB,sCAAsC;EACtC,8BAA8B;EAC9B,6BAA6B;EAC7B,4BAA4B;EAC5B,eAAe;EACf,oBAAoB;EACpB,sBAAsB;EACtB,uBAAuB;EACvB,wBAAwB;EACxB,kBAAkB;EAClB,2BAA2B;EAC3B,4BAA4B;EAC5B,sCAAsC;EACtC,kCAAkC;EAClC,2BAA2B;EAC3B,sBAAsB;EACtB,8BAA8B;EAC9B,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,2BAA2B;EAC3B,yBAAyB;EACzB,0BAA0B;EAC1B,2BAA2B;EAC3B,uBAAuB;EACvB,wBAAwB;EACxB,yBAAyB;EACzB,sBAAsB;EACtB,oBAAoB;EACpB,sBAAsB;EACtB,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,wBAAwB;EACxB,wBAAwB;EACxB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,cAAc;EACd,cAAc;EACd,eAAe;EACf,eAAe;EACf,aAAa;EACb,aAAa;EACb,kBAAkB;EAClB,sCAAsC;EACtC,8BAA8B;EAC9B,6BAA6B;EAC7B,4BAA4B;EAC5B,eAAe;EACf,oBAAoB;EACpB,sBAAsB;EACtB,uBAAuB;EACvB,wBAAwB;EACxB,kBAAkB;EAClB,2BAA2B;EAC3B,4BAA4B;EAC5B,sCAAsC;EACtC,kCAAkC;EAClC,2BAA2B;EAC3B,sBAAsB;EACtB,8BAA8B;EAC9B,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,2BAA2B;EAC3B,yBAAyB;EACzB,0BAA0B;EAC1B,2BAA2B;EAC3B,uBAAuB;EACvB,wBAAwB;EACxB,yBAAyB;EACzB,sBAAsB;EACtB,oBAAoB;EACpB,sBAAsB;EACtB,qBAAqB;EACrB,qBAAqB;AACvB;AACA;EACE,WAAW;AACb;AACA;;EAEE;IACE,gBAAgB;EAClB;AACF;AACA;;EAEE;IACE,gBAAgB;EAClB;AACF;AACA;;EAEE;IACE,iBAAiB;EACnB;AACF;AACA;;EAEE;IACE,iBAAiB;EACnB;AACF;AACA;;EAEE;IACE,iBAAiB;EACnB;AACF;AACA;EACE,+BAA+B;AACjC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,qBAAqB;AACvB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,sBAAsB;AACxB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,+BAA+B;AACjC;AACA;EACE,uBAAuB;AACzB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,8BAA8B;EAC9B,iCAAiC;AACnC;AACA;EACE,+BAA+B;EAC/B,kCAAkC;AACpC;AACA;EACE,2BAA2B;EAC3B,8BAA8B;AAChC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,+BAA+B;AACjC;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,gCAAgC;AAClC;AACA;EACE,+BAA+B;AACjC;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,8BAA8B;AAChC;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,8BAA8B;AAChC;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,gCAAgC;AAClC;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,+BAA+B;AACjC;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,sBAAsB;AACxB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,uBAAuB;AACzB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,uBAAuB;AACzB;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,uBAAuB;AACzB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,uBAAuB;AACzB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,qBAAqB;AACvB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,sBAAsB;AACxB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,qBAAqB;AACvB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,qBAAqB;AACvB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,uBAAuB;AACzB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,kCAAkC;EAClC,6BAA6B;AAC/B;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,uBAAuB;AACzB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,sCAAsC;EACtC,gFAAgF;AAClF;AACA;EACE,iCAAiC;EACjC,0MAA0M;AAC5M;AACA;EACE,8BAA8B;EAC9B,0MAA0M;AAC5M;AACA;EACE,0BAA0B;EAC1B,0BAA0B;EAC1B,0MAA0M;AAC5M;AACA;EACE,2BAA2B;EAC3B,2BAA2B;EAC3B,0MAA0M;AAC5M;AACA;EACE,0MAA0M;AAC5M;AACA;;EAEE;IACE,WAAW;EACb;AACF;AACA;EACE,oEAAoE;AACtE;AACA;;EAEE;IACE,yBAAyB;EAC3B;AACF;AACA;EACE,6CAA6C;AAC/C;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,8BAA8B;AAChC;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,mCAAmC;KAChC,gCAAgC;UAC3B,2BAA2B;AACrC;AACA;EACE,2DAA2D;AAC7D;AACA;EACE,2DAA2D;AAC7D;AACA;EACE,8BAA8B;AAChC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,yCAAyC;AAC3C;AACA;EACE,kCAAkC;AACpC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,oCAAoC;AACtC;AACA;EACE,kCAAkC;AACpC;AACA;EACE,yCAAyC;AAC3C;AACA;EACE,gCAAgC;AAClC;AACA;EACE,mBAAmB;AACrB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,uBAAuB;AACzB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,oBAAoB;AACtB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,oBAAoB;AACtB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,gCAAgC;OAC3B,2BAA2B;AAClC;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,kCAAkC;EAClC,uEAAuE;EACvE,gEAAgE;AAClE;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,8BAA8B;AAChC;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,8BAA8B;AAChC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,0CAA0C;AAC5C;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,mCAAmC;AACrC;AACA;EACE,mCAAmC;AACrC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,yCAAyC;AAC3C;AACA;EACE,qCAAqC;AACvC;AACA;EACE,iCAAiC;EACjC,oEAAoE;AACtE;AACA;EACE,iCAAiC;EACjC,oEAAoE;AACtE;AACA;EACE,iCAAiC;EACjC,oEAAoE;AACtE;AACA;EACE,iCAAiC;EACjC,kEAAkE;AACpE;AACA;EACE,iCAAiC;EACjC,iEAAiE;AACnE;AACA;EACE,iCAAiC;EACjC,oEAAoE;AACtE;AACA;EACE,oCAAoC;AACtC;AACA;EACE,0CAA0C;AAC5C;AACA;EACE,6BAA6B;EAC7B,mEAAmE;AACrE;AACA;EACE,6BAA6B;EAC7B,8DAA8D;AAChE;AACA;EACE,6BAA6B;EAC7B,oEAAoE;AACtE;AACA;EACE,6BAA6B;EAC7B,oEAAoE;AACtE;AACA;EACE,6BAA6B;EAC7B,oEAAoE;AACtE;AACA;EACE,6BAA6B;EAC7B,oEAAoE;AACtE;AACA;EACE,6BAA6B;EAC7B,kEAAkE;AACpE;AACA;EACE,6BAA6B;EAC7B,iEAAiE;AACnE;AACA;EACE,6BAA6B;EAC7B,oEAAoE;AACtE;AACA;EACE,6BAA6B;EAC7B,kEAAkE;AACpE;AACA;EACE,6BAA6B;EAC7B,iEAAiE;AACnE;AACA;EACE,6BAA6B;EAC7B,oEAAoE;AACtE;AACA;EACE,6BAA6B;EAC7B,oEAAoE;AACtE;AACA;EACE,6BAA6B;EAC7B,oEAAoE;AACtE;AACA;EACE,iFAAiF;AACnF;AACA;EACE,8EAA8E;AAChF;AACA;EACE,uEAAuE;EACvE,gFAAgF;EAChF,8EAA8E;AAChF;AACA;EACE,uEAAuE;EACvE,8EAA8E;EAC9E,8EAA8E;AAChF;AACA;EACE,uEAAuE;EACvE,8EAA8E;EAC9E,8EAA8E;AAChF;AACA;EACE,mEAAmE;AACrE;AACA;EACE,mEAAmE;AACrE;AACA;EACE,mEAAmE;AACrE;AACA;EACE,gCAAgC;AAClC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,uBAAuB;AACzB;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,6BAA6B;EAC7B,8BAA8B;AAChC;AACA;EACE,+BAA+B;EAC/B,gCAAgC;AAClC;AACA;EACE,iCAAiC;EACjC,kCAAkC;AACpC;AACA;EACE,gCAAgC;EAChC,iCAAiC;AACnC;AACA;EACE,6BAA6B;EAC7B,8BAA8B;AAChC;AACA;EACE,+BAA+B;EAC/B,gCAAgC;AAClC;AACA;EACE,+BAA+B;EAC/B,kCAAkC;AACpC;AACA;EACE,gCAAgC;EAChC,mCAAmC;AACrC;AACA;EACE,4BAA4B;EAC5B,+BAA+B;AACjC;AACA;EACE,8BAA8B;EAC9B,iCAAiC;AACnC;AACA;EACE,+BAA+B;EAC/B,kCAAkC;AACpC;AACA;EACE,4BAA4B;EAC5B,+BAA+B;AACjC;AACA;EACE,+BAA+B;EAC/B,kCAAkC;AACpC;AACA;EACE,4BAA4B;EAC5B,+BAA+B;AACjC;AACA;EACE,kCAAkC;AACpC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,iCAAiC;AACnC;AACA;EACE,mCAAmC;AACrC;AACA;EACE,0IAA0I;AAC5I;AACA;EACE,4BAA4B;EAC5B,4BAA4B;AAC9B;AACA;EACE,8BAA8B;EAC9B,+BAA+B;AACjC;AACA;EACE,6BAA6B;EAC7B,8BAA8B;AAChC;AACA;EACE,0BAA0B;EAC1B,yBAAyB;AAC3B;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,0BAA0B;EAC1B,8BAA8B;AAChC;AACA;EACE,8BAA8B;EAC9B,+BAA+B;AACjC;AACA;EACE,8BAA8B;EAC9B,+BAA+B;AACjC;AACA;EACE,6BAA6B;EAC7B,+BAA+B;AACjC;AACA;EACE,6BAA6B;EAC7B,4BAA4B;AAC9B;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,oCAAoC;AACtC;AACA;EACE,+BAA+B;AACjC;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,8BAA8B;AAChC;AACA;EACE,+BAA+B;EAC/B,yDAAyD;AAC3D;AACA;EACE,+BAA+B;EAC/B,qDAAqD;AACvD;AACA;EACE,mCAAmC;AACrC;AACA;EACE,kCAAkC;AACpC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,+BAA+B;EAC/B,2DAA2D;AAC7D;AACA;EACE,+BAA+B;EAC/B,wDAAwD;AAC1D;AACA;EACE,+BAA+B;EAC/B,yDAAyD;AAC3D;AACA;EACE,+BAA+B;EAC/B,2DAA2D;AAC7D;AACA;EACE,+BAA+B;EAC/B,2DAA2D;AAC7D;AACA;EACE,+BAA+B;EAC/B,yDAAyD;AAC3D;AACA;EACE,+BAA+B;EAC/B,2DAA2D;AAC7D;AACA;EACE,+BAA+B;EAC/B,2DAA2D;AAC7D;AACA;EACE,wCAAwC;AAC1C;AACA;EACE,0CAA0C;AAC5C;AACA;EACE,6CAA6C;AAC/C;AACA;EACE,qCAAqC;AACvC;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,uBAAuB;AACzB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,uBAAuB;AACzB;AACA;EACE,2DAA2D;EAC3D,wEAAwE;EACxE,kHAAkH;AACpH;AACA;EACE,wFAAwF;EACxF,4GAA4G;EAC5G,kHAAkH;AACpH;AACA;EACE,iCAAiC;EACjC,yCAAyC;EACzC,kHAAkH;AACpH;AACA;EACE,yCAAyC;EACzC,8BAA8B;AAChC;AACA;EACE,+BAA+B;AACjC;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,+BAA+B;EAC/B,4LAA4L;AAC9L;AACA;EACE,4LAA4L;AAC9L;AACA;EACE,2KAA2K;EAC3K,mKAAmK;EACnK,4LAA4L;EAC5L,mEAAmE;EACnE,qCAAqC;AACvC;AACA;EACE,mCAAmC;EACnC,mEAAmE;EACnE,qCAAqC;AACvC;AACA;EACE,yCAAyC;EACzC,mEAAmE;EACnE,qCAAqC;AACvC;AACA;EACE,iEAAiE;AACnE;AACA;IACI,oBAAoB;IACpB,gCAAgC;IAChC,6BAA6B;IAC7B,uBAAuB;IACvB,gCAAgC;IAChC,sBAAsB;EACxB;AACF;IACI,oBAAoB;EACtB;AACF;IACI,iCAAiC;EACnC;AACF;IACI,oCAAoC;EACtC;AACF;;IAEI,sEAAsE;EACxE;AACF;IACI,2CAA2C;EAC7C;AACF;IACI,sBAAsB;IACtB,6BAA6B;IAC7B,wBAAwB;IACxB,yBAAyB;IACzB,2CAA2C;IAC3C,uBAAuB;IACvB,wBAAwB;IACxB,6BAA6B;IAC7B,oDAAoD;IACpD,6BAA6B;IAC7B,wCAAwC;IACxC,+BAA+B;IAC/B,uBAAuB;EACzB;AACF;IACI,6BAA6B;EAC/B;AACF;IACI,qBAAqB;EACvB;AACF;IACI,iBAAiB;IACjB,kBAAkB;IAClB,mDAAmD;IACnD,qBAAqB;IACrB,wCAAwC;IACxC,uBAAuB;IACvB,wBAAwB;EAC1B;AACF;IACI,qCAAqC;EACvC;AACF;IACI,oCAAoC;EACtC;AACF;IACI,sBAAsB;EACxB;AACF;EACE,kBAAkB;EAClB,oBAAoB;EACpB,gBAAgB;EAChB,oBAAoB;EACpB,0CAA0C;AAC5C;AACA;EACE,8BAA8B;AAChC;AACA;EACE,iCAAiC;EACjC,kBAAkB;EAClB;mBACiB;AACnB;AACA;EACE,8BAA8B;EAC9B,kBAAkB;EAClB;mBACiB;AACnB;AACA;EACE,4CAA4C;AAC9C;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kCAAkC;AACpC;AACA;EACE,kCAAkC;AACpC;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,6BAA6B;EAC7B,8DAA8D;AAChE;AACA;EACE,6BAA6B;EAC7B,6BAA6B;EAC7B,0MAA0M;AAC5M;AACA;EACE,iCAAiC;EACjC,oEAAoE;AACtE;AACA;EACE,6BAA6B;EAC7B,8DAA8D;AAChE;AACA;EACE,6BAA6B;EAC7B,oEAAoE;AACtE;AACA;EACE,6BAA6B;EAC7B,oEAAoE;AACtE;AACA;EACE,6BAA6B;EAC7B,oEAAoE;AACtE;AACA;EACE,6BAA6B;EAC7B,oEAAoE;AACtE;AACA;EACE,6BAA6B;EAC7B,oEAAoE;AACtE;AACA;EACE,+BAA+B;EAC/B,qDAAqD;AACvD;AACA;EACE,+BAA+B;EAC/B,yDAAyD;AAC3D;AACA;EACE,+BAA+B;EAC/B,2DAA2D;AAC7D;AACA;EACE,0CAA0C;AAC5C;AACA;EACE,uBAAuB;AACzB;AACA;EACE,iCAAiC;EACjC,8DAA8D;AAChE;AACA;EACE,+BAA+B;EAC/B,qDAAqD;AACvD;AACA;EACE,+BAA+B;EAC/B,2DAA2D;AAC7D;AACA;EACE,yBAAyB;AAC3B;AACA;;EAEE;;IAEE;MACE,yBAAyB;IAC3B;EACF;;EAEA;IACE,+CAA+C;EACjD;AACF;AACA;;EAEE;IACE,2DAA2D;EAC7D;AACF;AACA;;EAEE;IACE,uCAAuC;EACzC;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,2DAA2D;EAC7D;;EAEA;IACE,2DAA2D;EAC7D;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,iCAAiC;EACnC;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,gCAAgC;EAClC;;EAEA;IACE,iCAAiC;EACnC;;EAEA;IACE,6BAA6B;IAC7B,8BAA8B;EAChC;;EAEA;IACE,4BAA4B;IAC5B,+BAA+B;EACjC;;EAEA;IACE,kCAAkC;EACpC;;EAEA;IACE,+BAA+B;EACjC;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,2BAA2B;EAC7B;AACF;AACA;;EAEE;IACE,yBAAyB;EAC3B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,2DAA2D;EAC7D;AACF;AACA;;EAEE;IACE,wBAAwB;EAC1B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,2DAA2D;EAC7D;;EAEA;IACE,2DAA2D;EAC7D;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,oCAAoC;EACtC;;EAEA;IACE,oBAAoB;EACtB;AACF;AACA;;EAEE;IACE,qBAAqB;EACvB;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,8BAA8B;EAChC;AACF;AACA;EACE,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,2BAA2B;EAC3B,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,SAAS;AACX;;AAEA;EACE,WAAW;EACX,WAAW;AACb;;AAEA;EACE,8DAA8D;AAChE;;AAEA;EACE,8DAA8D;AAChE;;AAEA;EACE,WAAW,cAAc,EAAE;EAC3B,MAAM,8BAA8B;AACtC;;AAEA;EACE,WAAW,cAAc,EAAE;EAC3B,MAAM,8BAA8B;AACtC","sourcesContent":["/*\n! tailwindcss v3.4.4 | MIT License | https://tailwindcss.com\n*//*\n1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)\n2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)\n*/\n\n*,\n::before,\n::after {\n  box-sizing: border-box; /* 1 */\n  border-width: 0; /* 2 */\n  border-style: solid; /* 2 */\n  border-color: #e5e7eb; /* 2 */\n}\n\n::before,\n::after {\n  --tw-content: '';\n}\n\n/*\n1. Use a consistent sensible line-height in all browsers.\n2. Prevent adjustments of font size after orientation changes in iOS.\n3. Use a more readable tab size.\n4. Use the user's configured `sans` font-family by default.\n5. Use the user's configured `sans` font-feature-settings by default.\n6. Use the user's configured `sans` font-variation-settings by default.\n7. Disable tap highlights on iOS\n*/\n\nhtml,\n:host {\n  line-height: 1.5; /* 1 */\n  -webkit-text-size-adjust: 100%; /* 2 */\n  -moz-tab-size: 4; /* 3 */\n  -o-tab-size: 4;\n     tab-size: 4; /* 3 */\n  font-family: ui-sans-serif, system-ui, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\"; /* 4 */\n  font-feature-settings: normal; /* 5 */\n  font-variation-settings: normal; /* 6 */\n  -webkit-tap-highlight-color: transparent; /* 7 */\n}\n\n/*\n1. Remove the margin in all browsers.\n2. Inherit line-height from `html` so users can set them as a class directly on the `html` element.\n*/\n\nbody {\n  margin: 0; /* 1 */\n  line-height: inherit; /* 2 */\n}\n\n/*\n1. Add the correct height in Firefox.\n2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)\n3. Ensure horizontal rules are visible by default.\n*/\n\nhr {\n  height: 0; /* 1 */\n  color: inherit; /* 2 */\n  border-top-width: 1px; /* 3 */\n}\n\n/*\nAdd the correct text decoration in Chrome, Edge, and Safari.\n*/\n\nabbr:where([title]) {\n  -webkit-text-decoration: underline dotted;\n          text-decoration: underline dotted;\n}\n\n/*\nRemove the default font size and weight for headings.\n*/\n\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n  font-size: inherit;\n  font-weight: inherit;\n}\n\n/*\nReset links to optimize for opt-in styling instead of opt-out.\n*/\n\na {\n  color: inherit;\n  text-decoration: inherit;\n}\n\n/*\nAdd the correct font weight in Edge and Safari.\n*/\n\nb,\nstrong {\n  font-weight: bolder;\n}\n\n/*\n1. Use the user's configured `mono` font-family by default.\n2. Use the user's configured `mono` font-feature-settings by default.\n3. Use the user's configured `mono` font-variation-settings by default.\n4. Correct the odd `em` font sizing in all browsers.\n*/\n\ncode,\nkbd,\nsamp,\npre {\n  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace; /* 1 */\n  font-feature-settings: normal; /* 2 */\n  font-variation-settings: normal; /* 3 */\n  font-size: 1em; /* 4 */\n}\n\n/*\nAdd the correct font size in all browsers.\n*/\n\nsmall {\n  font-size: 80%;\n}\n\n/*\nPrevent `sub` and `sup` elements from affecting the line height in all browsers.\n*/\n\nsub,\nsup {\n  font-size: 75%;\n  line-height: 0;\n  position: relative;\n  vertical-align: baseline;\n}\n\nsub {\n  bottom: -0.25em;\n}\n\nsup {\n  top: -0.5em;\n}\n\n/*\n1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)\n2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)\n3. Remove gaps between table borders by default.\n*/\n\ntable {\n  text-indent: 0; /* 1 */\n  border-color: inherit; /* 2 */\n  border-collapse: collapse; /* 3 */\n}\n\n/*\n1. Change the font styles in all browsers.\n2. Remove the margin in Firefox and Safari.\n3. Remove default padding in all browsers.\n*/\n\nbutton,\ninput,\noptgroup,\nselect,\ntextarea {\n  font-family: inherit; /* 1 */\n  font-feature-settings: inherit; /* 1 */\n  font-variation-settings: inherit; /* 1 */\n  font-size: 100%; /* 1 */\n  font-weight: inherit; /* 1 */\n  line-height: inherit; /* 1 */\n  letter-spacing: inherit; /* 1 */\n  color: inherit; /* 1 */\n  margin: 0; /* 2 */\n  padding: 0; /* 3 */\n}\n\n/*\nRemove the inheritance of text transform in Edge and Firefox.\n*/\n\nbutton,\nselect {\n  text-transform: none;\n}\n\n/*\n1. Correct the inability to style clickable types in iOS and Safari.\n2. Remove default button styles.\n*/\n\nbutton,\ninput:where([type='button']),\ninput:where([type='reset']),\ninput:where([type='submit']) {\n  -webkit-appearance: button; /* 1 */\n  background-color: transparent; /* 2 */\n  background-image: none; /* 2 */\n}\n\n/*\nUse the modern Firefox focus style for all focusable elements.\n*/\n\n:-moz-focusring {\n  outline: auto;\n}\n\n/*\nRemove the additional `:invalid` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)\n*/\n\n:-moz-ui-invalid {\n  box-shadow: none;\n}\n\n/*\nAdd the correct vertical alignment in Chrome and Firefox.\n*/\n\nprogress {\n  vertical-align: baseline;\n}\n\n/*\nCorrect the cursor style of increment and decrement buttons in Safari.\n*/\n\n::-webkit-inner-spin-button,\n::-webkit-outer-spin-button {\n  height: auto;\n}\n\n/*\n1. Correct the odd appearance in Chrome and Safari.\n2. Correct the outline style in Safari.\n*/\n\n[type='search'] {\n  -webkit-appearance: textfield; /* 1 */\n  outline-offset: -2px; /* 2 */\n}\n\n/*\nRemove the inner padding in Chrome and Safari on macOS.\n*/\n\n::-webkit-search-decoration {\n  -webkit-appearance: none;\n}\n\n/*\n1. Correct the inability to style clickable types in iOS and Safari.\n2. Change font properties to `inherit` in Safari.\n*/\n\n::-webkit-file-upload-button {\n  -webkit-appearance: button; /* 1 */\n  font: inherit; /* 2 */\n}\n\n/*\nAdd the correct display in Chrome and Safari.\n*/\n\nsummary {\n  display: list-item;\n}\n\n/*\nRemoves the default spacing and border for appropriate elements.\n*/\n\nblockquote,\ndl,\ndd,\nh1,\nh2,\nh3,\nh4,\nh5,\nh6,\nhr,\nfigure,\np,\npre {\n  margin: 0;\n}\n\nfieldset {\n  margin: 0;\n  padding: 0;\n}\n\nlegend {\n  padding: 0;\n}\n\nol,\nul,\nmenu {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n}\n\n/*\nReset default styling for dialogs.\n*/\ndialog {\n  padding: 0;\n}\n\n/*\nPrevent resizing textareas horizontally by default.\n*/\n\ntextarea {\n  resize: vertical;\n}\n\n/*\n1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)\n2. Set the default placeholder color to the user's configured gray 400 color.\n*/\n\ninput::-moz-placeholder, textarea::-moz-placeholder {\n  opacity: 1; /* 1 */\n  color: #9ca3af; /* 2 */\n}\n\ninput::placeholder,\ntextarea::placeholder {\n  opacity: 1; /* 1 */\n  color: #9ca3af; /* 2 */\n}\n\n/*\nSet the default cursor for buttons.\n*/\n\nbutton,\n[role=\"button\"] {\n  cursor: pointer;\n}\n\n/*\nMake sure disabled buttons don't get the pointer cursor.\n*/\n:disabled {\n  cursor: default;\n}\n\n/*\n1. Make replaced elements `display: block` by default. (https://github.com/mozdevs/cssremedy/issues/14)\n2. Add `vertical-align: middle` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)\n   This can trigger a poorly considered lint error in some tools but is included by design.\n*/\n\nimg,\nsvg,\nvideo,\ncanvas,\naudio,\niframe,\nembed,\nobject {\n  display: block; /* 1 */\n  vertical-align: middle; /* 2 */\n}\n\n/*\nConstrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)\n*/\n\nimg,\nvideo {\n  max-width: 100%;\n  height: auto;\n}\n\n/* Make elements with the HTML hidden attribute stay hidden by default */\n[hidden] {\n  display: none;\n}\n  html {\n    font-family: 'ABCDiatype-Regular', system-ui, sans-serif;\n  }\n\n*, ::before, ::after {\n  --tw-border-spacing-x: 0;\n  --tw-border-spacing-y: 0;\n  --tw-translate-x: 0;\n  --tw-translate-y: 0;\n  --tw-rotate: 0;\n  --tw-skew-x: 0;\n  --tw-skew-y: 0;\n  --tw-scale-x: 1;\n  --tw-scale-y: 1;\n  --tw-pan-x:  ;\n  --tw-pan-y:  ;\n  --tw-pinch-zoom:  ;\n  --tw-scroll-snap-strictness: proximity;\n  --tw-gradient-from-position:  ;\n  --tw-gradient-via-position:  ;\n  --tw-gradient-to-position:  ;\n  --tw-ordinal:  ;\n  --tw-slashed-zero:  ;\n  --tw-numeric-figure:  ;\n  --tw-numeric-spacing:  ;\n  --tw-numeric-fraction:  ;\n  --tw-ring-inset:  ;\n  --tw-ring-offset-width: 0px;\n  --tw-ring-offset-color: #fff;\n  --tw-ring-color: rgb(59 130 246 / 0.5);\n  --tw-ring-offset-shadow: 0 0 #0000;\n  --tw-ring-shadow: 0 0 #0000;\n  --tw-shadow: 0 0 #0000;\n  --tw-shadow-colored: 0 0 #0000;\n  --tw-blur:  ;\n  --tw-brightness:  ;\n  --tw-contrast:  ;\n  --tw-grayscale:  ;\n  --tw-hue-rotate:  ;\n  --tw-invert:  ;\n  --tw-saturate:  ;\n  --tw-sepia:  ;\n  --tw-drop-shadow:  ;\n  --tw-backdrop-blur:  ;\n  --tw-backdrop-brightness:  ;\n  --tw-backdrop-contrast:  ;\n  --tw-backdrop-grayscale:  ;\n  --tw-backdrop-hue-rotate:  ;\n  --tw-backdrop-invert:  ;\n  --tw-backdrop-opacity:  ;\n  --tw-backdrop-saturate:  ;\n  --tw-backdrop-sepia:  ;\n  --tw-contain-size:  ;\n  --tw-contain-layout:  ;\n  --tw-contain-paint:  ;\n  --tw-contain-style:  ;\n}\n\n::backdrop {\n  --tw-border-spacing-x: 0;\n  --tw-border-spacing-y: 0;\n  --tw-translate-x: 0;\n  --tw-translate-y: 0;\n  --tw-rotate: 0;\n  --tw-skew-x: 0;\n  --tw-skew-y: 0;\n  --tw-scale-x: 1;\n  --tw-scale-y: 1;\n  --tw-pan-x:  ;\n  --tw-pan-y:  ;\n  --tw-pinch-zoom:  ;\n  --tw-scroll-snap-strictness: proximity;\n  --tw-gradient-from-position:  ;\n  --tw-gradient-via-position:  ;\n  --tw-gradient-to-position:  ;\n  --tw-ordinal:  ;\n  --tw-slashed-zero:  ;\n  --tw-numeric-figure:  ;\n  --tw-numeric-spacing:  ;\n  --tw-numeric-fraction:  ;\n  --tw-ring-inset:  ;\n  --tw-ring-offset-width: 0px;\n  --tw-ring-offset-color: #fff;\n  --tw-ring-color: rgb(59 130 246 / 0.5);\n  --tw-ring-offset-shadow: 0 0 #0000;\n  --tw-ring-shadow: 0 0 #0000;\n  --tw-shadow: 0 0 #0000;\n  --tw-shadow-colored: 0 0 #0000;\n  --tw-blur:  ;\n  --tw-brightness:  ;\n  --tw-contrast:  ;\n  --tw-grayscale:  ;\n  --tw-hue-rotate:  ;\n  --tw-invert:  ;\n  --tw-saturate:  ;\n  --tw-sepia:  ;\n  --tw-drop-shadow:  ;\n  --tw-backdrop-blur:  ;\n  --tw-backdrop-brightness:  ;\n  --tw-backdrop-contrast:  ;\n  --tw-backdrop-grayscale:  ;\n  --tw-backdrop-hue-rotate:  ;\n  --tw-backdrop-invert:  ;\n  --tw-backdrop-opacity:  ;\n  --tw-backdrop-saturate:  ;\n  --tw-backdrop-sepia:  ;\n  --tw-contain-size:  ;\n  --tw-contain-layout:  ;\n  --tw-contain-paint:  ;\n  --tw-contain-style:  ;\n}\n.container {\n  width: 100%;\n}\n@media (min-width: 640px) {\n\n  .container {\n    max-width: 640px;\n  }\n}\n@media (min-width: 768px) {\n\n  .container {\n    max-width: 768px;\n  }\n}\n@media (min-width: 1024px) {\n\n  .container {\n    max-width: 1024px;\n  }\n}\n@media (min-width: 1280px) {\n\n  .container {\n    max-width: 1280px;\n  }\n}\n@media (min-width: 1536px) {\n\n  .container {\n    max-width: 1536px;\n  }\n}\n.pointer-events-none {\n  pointer-events: none !important;\n}\n.visible {\n  visibility: visible !important;\n}\n.fixed {\n  position: fixed !important;\n}\n.\\!absolute {\n  position: absolute !important;\n}\n.absolute {\n  position: absolute !important;\n}\n.relative {\n  position: relative !important;\n}\n.sticky {\n  position: sticky !important;\n}\n.inset-0 {\n  inset: 0px !important;\n}\n.-top-1 {\n  top: -0.25rem !important;\n}\n.-top-1\\.5 {\n  top: -0.375rem !important;\n}\n.bottom-0 {\n  bottom: 0px !important;\n}\n.bottom-4 {\n  bottom: 1rem !important;\n}\n.left-auto {\n  left: auto !important;\n}\n.right-0 {\n  right: 0px !important;\n}\n.right-4 {\n  right: 1rem !important;\n}\n.top-0 {\n  top: 0px !important;\n}\n.top-1\\/2 {\n  top: 50% !important;\n}\n.top-12 {\n  top: 3rem !important;\n}\n.top-2 {\n  top: 0.5rem !important;\n}\n.-z-10 {\n  z-index: -10 !important;\n}\n.z-10 {\n  z-index: 10 !important;\n}\n.z-40 {\n  z-index: 40 !important;\n}\n.z-50 {\n  z-index: 50 !important;\n}\n.col-start-1 {\n  grid-column-start: 1 !important;\n}\n.\\!-m-px {\n  margin: -1px !important;\n}\n.m-0 {\n  margin: 0px !important;\n}\n.m-auto {\n  margin: auto !important;\n}\n.my-1 {\n  margin-top: 0.25rem !important;\n  margin-bottom: 0.25rem !important;\n}\n.my-1\\.5 {\n  margin-top: 0.375rem !important;\n  margin-bottom: 0.375rem !important;\n}\n.my-4 {\n  margin-top: 1rem !important;\n  margin-bottom: 1rem !important;\n}\n.-mt-6 {\n  margin-top: -1.5rem !important;\n}\n.mb-1 {\n  margin-bottom: 0.25rem !important;\n}\n.mb-2 {\n  margin-bottom: 0.5rem !important;\n}\n.mb-4 {\n  margin-bottom: 1rem !important;\n}\n.mb-6 {\n  margin-bottom: 1.5rem !important;\n}\n.ml-1 {\n  margin-left: 0.25rem !important;\n}\n.ml-px {\n  margin-left: 1px !important;\n}\n.mr-1 {\n  margin-right: 0.25rem !important;\n}\n.mr-2 {\n  margin-right: 0.5rem !important;\n}\n.mr-8 {\n  margin-right: 2rem !important;\n}\n.mt-1 {\n  margin-top: 0.25rem !important;\n}\n.mt-10 {\n  margin-top: 2.5rem !important;\n}\n.mt-12 {\n  margin-top: 3rem !important;\n}\n.mt-5 {\n  margin-top: 1.25rem !important;\n}\n.mt-6 {\n  margin-top: 1.5rem !important;\n}\n.mt-8 {\n  margin-top: 2rem !important;\n}\n.block {\n  display: block !important;\n}\n.inline-block {\n  display: inline-block !important;\n}\n.inline {\n  display: inline !important;\n}\n.flex {\n  display: flex !important;\n}\n.inline-flex {\n  display: inline-flex !important;\n}\n.table {\n  display: table !important;\n}\n.grid {\n  display: grid !important;\n}\n.hidden {\n  display: none !important;\n}\n.\\!h-px {\n  height: 1px !important;\n}\n.h-10 {\n  height: 2.5rem !important;\n}\n.h-12 {\n  height: 3rem !important;\n}\n.h-16 {\n  height: 4rem !important;\n}\n.h-2 {\n  height: 0.5rem !important;\n}\n.h-3 {\n  height: 0.75rem !important;\n}\n.h-3\\.5 {\n  height: 0.875rem !important;\n}\n.h-4 {\n  height: 1rem !important;\n}\n.h-5 {\n  height: 1.25rem !important;\n}\n.h-56 {\n  height: 14rem !important;\n}\n.h-6 {\n  height: 1.5rem !important;\n}\n.h-60 {\n  height: 15rem !important;\n}\n.h-8 {\n  height: 2rem !important;\n}\n.h-\\[100px\\] {\n  height: 100px !important;\n}\n.h-\\[109px\\] {\n  height: 109px !important;\n}\n.h-\\[180px\\] {\n  height: 180px !important;\n}\n.h-\\[200px\\] {\n  height: 200px !important;\n}\n.h-\\[73px\\] {\n  height: 73px !important;\n}\n.h-full {\n  height: 100% !important;\n}\n.h-px {\n  height: 1px !important;\n}\n.max-h-64 {\n  max-height: 16rem !important;\n}\n.min-h-36 {\n  min-height: 9rem !important;\n}\n.min-h-60 {\n  min-height: 15rem !important;\n}\n.min-h-72 {\n  min-height: 18rem !important;\n}\n.\\!w-px {\n  width: 1px !important;\n}\n.w-10 {\n  width: 2.5rem !important;\n}\n.w-12 {\n  width: 3rem !important;\n}\n.w-16 {\n  width: 4rem !important;\n}\n.w-2 {\n  width: 0.5rem !important;\n}\n.w-2\\/4 {\n  width: 50% !important;\n}\n.w-3 {\n  width: 0.75rem !important;\n}\n.w-3\\.5 {\n  width: 0.875rem !important;\n}\n.w-3\\/4 {\n  width: 75% !important;\n}\n.w-4 {\n  width: 1rem !important;\n}\n.w-5 {\n  width: 1.25rem !important;\n}\n.w-5\\/6 {\n  width: 83.333333% !important;\n}\n.w-6 {\n  width: 1.5rem !important;\n}\n.w-60 {\n  width: 15rem !important;\n}\n.w-8 {\n  width: 2rem !important;\n}\n.w-\\[14px\\] {\n  width: 14px !important;\n}\n.w-\\[40px\\] {\n  width: 40px !important;\n}\n.w-auto {\n  width: auto !important;\n}\n.w-full {\n  width: 100% !important;\n}\n.w-max {\n  width: -moz-max-content !important;\n  width: max-content !important;\n}\n.min-w-56 {\n  min-width: 14rem !important;\n}\n.min-w-64 {\n  min-width: 16rem !important;\n}\n.min-w-8 {\n  min-width: 2rem !important;\n}\n.min-w-\\[14px\\] {\n  min-width: 14px !important;\n}\n.max-w-64 {\n  max-width: 16rem !important;\n}\n.max-w-7xl {\n  max-width: 80rem !important;\n}\n.max-w-96 {\n  max-width: 24rem !important;\n}\n.max-w-\\[472px\\] {\n  max-width: 472px !important;\n}\n.max-w-\\[800px\\] {\n  max-width: 800px !important;\n}\n.max-w-full {\n  max-width: 100% !important;\n}\n.max-w-lg {\n  max-width: 32rem !important;\n}\n.flex-1 {\n  flex: 1 1 0% !important;\n}\n.shrink-0 {\n  flex-shrink: 0 !important;\n}\n.border-spacing-x-4 {\n  --tw-border-spacing-x: 1rem !important;\n  border-spacing: var(--tw-border-spacing-x) var(--tw-border-spacing-y) !important;\n}\n.-translate-y-1\\/2 {\n  --tw-translate-y: -50% !important;\n  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;\n}\n.rotate-180 {\n  --tw-rotate: 180deg !important;\n  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;\n}\n.scale-100 {\n  --tw-scale-x: 1 !important;\n  --tw-scale-y: 1 !important;\n  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;\n}\n.scale-90 {\n  --tw-scale-x: .9 !important;\n  --tw-scale-y: .9 !important;\n  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;\n}\n.transform {\n  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;\n}\n@keyframes pulse {\n\n  50% {\n    opacity: .5;\n  }\n}\n.animate-pulse {\n  animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite !important;\n}\n@keyframes spin {\n\n  to {\n    transform: rotate(360deg);\n  }\n}\n.animate-spin {\n  animation: spin 1s linear infinite !important;\n}\n.cursor-no-drop {\n  cursor: no-drop !important;\n}\n.cursor-not-allowed {\n  cursor: not-allowed !important;\n}\n.cursor-pointer {\n  cursor: pointer !important;\n}\n.appearance-none {\n  -webkit-appearance: none !important;\n     -moz-appearance: none !important;\n          appearance: none !important;\n}\n.grid-cols-1 {\n  grid-template-columns: repeat(1, minmax(0, 1fr)) !important;\n}\n.grid-cols-2 {\n  grid-template-columns: repeat(2, minmax(0, 1fr)) !important;\n}\n.flex-row {\n  flex-direction: row !important;\n}\n.flex-col {\n  flex-direction: column !important;\n}\n.flex-col-reverse {\n  flex-direction: column-reverse !important;\n}\n.items-start {\n  align-items: flex-start !important;\n}\n.items-center {\n  align-items: center !important;\n}\n.justify-end {\n  justify-content: flex-end !important;\n}\n.justify-center {\n  justify-content: center !important;\n}\n.justify-between {\n  justify-content: space-between !important;\n}\n.justify-items-center {\n  justify-items: center !important;\n}\n.gap-0 {\n  gap: 0px !important;\n}\n.gap-0\\.5 {\n  gap: 0.125rem !important;\n}\n.gap-1 {\n  gap: 0.25rem !important;\n}\n.gap-1\\.5 {\n  gap: 0.375rem !important;\n}\n.gap-12 {\n  gap: 3rem !important;\n}\n.gap-2 {\n  gap: 0.5rem !important;\n}\n.gap-2\\.5 {\n  gap: 0.625rem !important;\n}\n.gap-24 {\n  gap: 6rem !important;\n}\n.gap-3 {\n  gap: 0.75rem !important;\n}\n.gap-4 {\n  gap: 1rem !important;\n}\n.gap-5 {\n  gap: 1.25rem !important;\n}\n.gap-6 {\n  gap: 1.5rem !important;\n}\n.gap-7 {\n  gap: 1.75rem !important;\n}\n.gap-8 {\n  gap: 2rem !important;\n}\n.gap-x-24 {\n  -moz-column-gap: 6rem !important;\n       column-gap: 6rem !important;\n}\n.gap-y-2 {\n  row-gap: 0.5rem !important;\n}\n.gap-y-3 {\n  row-gap: 0.75rem !important;\n}\n.space-y-4 > :not([hidden]) ~ :not([hidden]) {\n  --tw-space-y-reverse: 0 !important;\n  margin-top: calc(1rem * calc(1 - var(--tw-space-y-reverse))) !important;\n  margin-bottom: calc(1rem * var(--tw-space-y-reverse)) !important;\n}\n.self-center {\n  align-self: center !important;\n}\n.self-stretch {\n  align-self: stretch !important;\n}\n.overflow-auto {\n  overflow: auto !important;\n}\n.\\!overflow-hidden {\n  overflow: hidden !important;\n}\n.overflow-hidden {\n  overflow: hidden !important;\n}\n.overflow-y-auto {\n  overflow-y: auto !important;\n}\n.\\!whitespace-nowrap {\n  white-space: nowrap !important;\n}\n.rounded {\n  border-radius: 0.25rem !important;\n}\n.rounded-2xl {\n  border-radius: 1rem !important;\n}\n.rounded-3xl {\n  border-radius: 1.5rem !important;\n}\n.rounded-\\[32px\\] {\n  border-radius: 32px !important;\n}\n.rounded-full {\n  border-radius: 9999px !important;\n}\n.rounded-lg {\n  border-radius: 0.5rem !important;\n}\n.rounded-xl {\n  border-radius: 0.75rem !important;\n}\n.rounded-bl-2xl {\n  border-bottom-left-radius: 1rem !important;\n}\n.\\!border-0 {\n  border-width: 0px !important;\n}\n.border {\n  border-width: 1px !important;\n}\n.border-0 {\n  border-width: 0px !important;\n}\n.border-2 {\n  border-width: 2px !important;\n}\n.border-4 {\n  border-width: 4px !important;\n}\n.border-b {\n  border-bottom-width: 1px !important;\n}\n.border-b-0 {\n  border-bottom-width: 0px !important;\n}\n.border-t {\n  border-top-width: 1px !important;\n}\n.border-solid {\n  border-style: solid !important;\n}\n.border-black\\/10 {\n  border-color: rgb(0 0 0 / 0.1) !important;\n}\n.border-current {\n  border-color: currentColor !important;\n}\n.border-gray-200 {\n  --tw-border-opacity: 1 !important;\n  border-color: rgb(229 231 235 / var(--tw-border-opacity)) !important;\n}\n.border-gray-300 {\n  --tw-border-opacity: 1 !important;\n  border-color: rgb(209 213 219 / var(--tw-border-opacity)) !important;\n}\n.border-neutral-300 {\n  --tw-border-opacity: 1 !important;\n  border-color: rgb(212 212 212 / var(--tw-border-opacity)) !important;\n}\n.border-red-600 {\n  --tw-border-opacity: 1 !important;\n  border-color: rgb(220 38 38 / var(--tw-border-opacity)) !important;\n}\n.border-slate-700 {\n  --tw-border-opacity: 1 !important;\n  border-color: rgb(51 65 85 / var(--tw-border-opacity)) !important;\n}\n.border-smokeWhite {\n  --tw-border-opacity: 1 !important;\n  border-color: rgb(240 240 240 / var(--tw-border-opacity)) !important;\n}\n.border-transparent {\n  border-color: transparent !important;\n}\n.border-r-transparent {\n  border-right-color: transparent !important;\n}\n.bg-amber-500 {\n  --tw-bg-opacity: 1 !important;\n  background-color: rgb(245 158 11 / var(--tw-bg-opacity)) !important;\n}\n.bg-black {\n  --tw-bg-opacity: 1 !important;\n  background-color: rgb(0 0 0 / var(--tw-bg-opacity)) !important;\n}\n.bg-gray-100 {\n  --tw-bg-opacity: 1 !important;\n  background-color: rgb(243 244 246 / var(--tw-bg-opacity)) !important;\n}\n.bg-gray-200 {\n  --tw-bg-opacity: 1 !important;\n  background-color: rgb(229 231 235 / var(--tw-bg-opacity)) !important;\n}\n.bg-gray-300 {\n  --tw-bg-opacity: 1 !important;\n  background-color: rgb(209 213 219 / var(--tw-bg-opacity)) !important;\n}\n.bg-green-50 {\n  --tw-bg-opacity: 1 !important;\n  background-color: rgb(240 253 244 / var(--tw-bg-opacity)) !important;\n}\n.bg-green-600 {\n  --tw-bg-opacity: 1 !important;\n  background-color: rgb(22 163 74 / var(--tw-bg-opacity)) !important;\n}\n.bg-neutral-950 {\n  --tw-bg-opacity: 1 !important;\n  background-color: rgb(10 10 10 / var(--tw-bg-opacity)) !important;\n}\n.bg-offWhite {\n  --tw-bg-opacity: 1 !important;\n  background-color: rgb(250 250 250 / var(--tw-bg-opacity)) !important;\n}\n.bg-red-600 {\n  --tw-bg-opacity: 1 !important;\n  background-color: rgb(220 38 38 / var(--tw-bg-opacity)) !important;\n}\n.bg-slate-900 {\n  --tw-bg-opacity: 1 !important;\n  background-color: rgb(15 23 42 / var(--tw-bg-opacity)) !important;\n}\n.bg-smokeWhite {\n  --tw-bg-opacity: 1 !important;\n  background-color: rgb(240 240 240 / var(--tw-bg-opacity)) !important;\n}\n.bg-white {\n  --tw-bg-opacity: 1 !important;\n  background-color: rgb(255 255 255 / var(--tw-bg-opacity)) !important;\n}\n.bg-zinc-50 {\n  --tw-bg-opacity: 1 !important;\n  background-color: rgb(250 250 250 / var(--tw-bg-opacity)) !important;\n}\n.bg-gradient-to-b {\n  background-image: linear-gradient(to bottom, var(--tw-gradient-stops)) !important;\n}\n.bg-gradient-to-t {\n  background-image: linear-gradient(to top, var(--tw-gradient-stops)) !important;\n}\n.from-gray-50 {\n  --tw-gradient-from: #f9fafb var(--tw-gradient-from-position) !important;\n  --tw-gradient-to: rgb(249 250 251 / 0) var(--tw-gradient-to-position) !important;\n  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to) !important;\n}\n.from-green-700 {\n  --tw-gradient-from: #15803d var(--tw-gradient-from-position) !important;\n  --tw-gradient-to: rgb(21 128 61 / 0) var(--tw-gradient-to-position) !important;\n  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to) !important;\n}\n.from-red-700 {\n  --tw-gradient-from: #b91c1c var(--tw-gradient-from-position) !important;\n  --tw-gradient-to: rgb(185 28 28 / 0) var(--tw-gradient-to-position) !important;\n  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to) !important;\n}\n.to-gray-100 {\n  --tw-gradient-to: #f3f4f6 var(--tw-gradient-to-position) !important;\n}\n.to-green-600 {\n  --tw-gradient-to: #16a34a var(--tw-gradient-to-position) !important;\n}\n.to-red-600 {\n  --tw-gradient-to: #dc2626 var(--tw-gradient-to-position) !important;\n}\n.bg-auto {\n  background-size: auto !important;\n}\n.fill-black\\/\\[\\.5\\] {\n  fill: rgb(0 0 0 / .5) !important;\n}\n.\\!p-0 {\n  padding: 0px !important;\n}\n.p-2 {\n  padding: 0.5rem !important;\n}\n.p-2\\.5 {\n  padding: 0.625rem !important;\n}\n.p-3 {\n  padding: 0.75rem !important;\n}\n.p-4 {\n  padding: 1rem !important;\n}\n.p-6 {\n  padding: 1.5rem !important;\n}\n.p-8 {\n  padding: 2rem !important;\n}\n.px-12 {\n  padding-left: 3rem !important;\n  padding-right: 3rem !important;\n}\n.px-2 {\n  padding-left: 0.5rem !important;\n  padding-right: 0.5rem !important;\n}\n.px-2\\.5 {\n  padding-left: 0.625rem !important;\n  padding-right: 0.625rem !important;\n}\n.px-3 {\n  padding-left: 0.75rem !important;\n  padding-right: 0.75rem !important;\n}\n.px-4 {\n  padding-left: 1rem !important;\n  padding-right: 1rem !important;\n}\n.px-6 {\n  padding-left: 1.5rem !important;\n  padding-right: 1.5rem !important;\n}\n.py-1 {\n  padding-top: 0.25rem !important;\n  padding-bottom: 0.25rem !important;\n}\n.py-1\\.5 {\n  padding-top: 0.375rem !important;\n  padding-bottom: 0.375rem !important;\n}\n.py-12 {\n  padding-top: 3rem !important;\n  padding-bottom: 3rem !important;\n}\n.py-2 {\n  padding-top: 0.5rem !important;\n  padding-bottom: 0.5rem !important;\n}\n.py-3 {\n  padding-top: 0.75rem !important;\n  padding-bottom: 0.75rem !important;\n}\n.py-4 {\n  padding-top: 1rem !important;\n  padding-bottom: 1rem !important;\n}\n.py-5 {\n  padding-top: 1.25rem !important;\n  padding-bottom: 1.25rem !important;\n}\n.py-8 {\n  padding-top: 2rem !important;\n  padding-bottom: 2rem !important;\n}\n.pb-5 {\n  padding-bottom: 1.25rem !important;\n}\n.pt-2 {\n  padding-top: 0.5rem !important;\n}\n.text-left {\n  text-align: left !important;\n}\n.text-center {\n  text-align: center !important;\n}\n.text-right {\n  text-align: right !important;\n}\n.text-start {\n  text-align: start !important;\n}\n.align-middle {\n  vertical-align: middle !important;\n}\n.align-\\[-0\\.125em\\] {\n  vertical-align: -0.125em !important;\n}\n.font-sans {\n  font-family: ui-sans-serif, system-ui, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\" !important;\n}\n.text-2xl {\n  font-size: 1.5rem !important;\n  line-height: 2rem !important;\n}\n.text-3xl {\n  font-size: 1.875rem !important;\n  line-height: 2.25rem !important;\n}\n.text-4xl {\n  font-size: 2.25rem !important;\n  line-height: 2.5rem !important;\n}\n.text-5xl {\n  font-size: 3rem !important;\n  line-height: 1 !important;\n}\n.text-\\[28px\\] {\n  font-size: 28px !important;\n}\n.text-\\[32px\\] {\n  font-size: 32px !important;\n}\n.text-base {\n  font-size: 1rem !important;\n  line-height: 1.5rem !important;\n}\n.text-lg {\n  font-size: 1.125rem !important;\n  line-height: 1.75rem !important;\n}\n.text-sm {\n  font-size: 0.875rem !important;\n  line-height: 1.25rem !important;\n}\n.text-xl {\n  font-size: 1.25rem !important;\n  line-height: 1.75rem !important;\n}\n.text-xs {\n  font-size: 0.75rem !important;\n  line-height: 1rem !important;\n}\n.font-bold {\n  font-weight: 700 !important;\n}\n.font-extrabold {\n  font-weight: 800 !important;\n}\n.font-medium {\n  font-weight: 500 !important;\n}\n.font-normal {\n  font-weight: 400 !important;\n}\n.font-semibold {\n  font-weight: 600 !important;\n}\n.uppercase {\n  text-transform: uppercase !important;\n}\n.leading-5 {\n  line-height: 1.25rem !important;\n}\n.leading-normal {\n  line-height: 1.5 !important;\n}\n.tracking-\\[2px\\] {\n  letter-spacing: 2px !important;\n}\n.text-\\[\\#DC2626\\] {\n  --tw-text-opacity: 1 !important;\n  color: rgb(220 38 38 / var(--tw-text-opacity)) !important;\n}\n.text-black {\n  --tw-text-opacity: 1 !important;\n  color: rgb(0 0 0 / var(--tw-text-opacity)) !important;\n}\n.text-black\\/25 {\n  color: rgb(0 0 0 / 0.25) !important;\n}\n.text-black\\/\\[\\.38\\] {\n  color: rgb(0 0 0 / .38) !important;\n}\n.text-black\\/\\[\\.5\\] {\n  color: rgb(0 0 0 / .5) !important;\n}\n.text-disabledGray {\n  --tw-text-opacity: 1 !important;\n  color: rgb(119 119 119 / var(--tw-text-opacity)) !important;\n}\n.text-gray-600 {\n  --tw-text-opacity: 1 !important;\n  color: rgb(75 85 99 / var(--tw-text-opacity)) !important;\n}\n.text-green-700 {\n  --tw-text-opacity: 1 !important;\n  color: rgb(21 128 61 / var(--tw-text-opacity)) !important;\n}\n.text-orange-300 {\n  --tw-text-opacity: 1 !important;\n  color: rgb(253 186 116 / var(--tw-text-opacity)) !important;\n}\n.text-quickSilver {\n  --tw-text-opacity: 1 !important;\n  color: rgb(161 161 161 / var(--tw-text-opacity)) !important;\n}\n.text-red-600 {\n  --tw-text-opacity: 1 !important;\n  color: rgb(220 38 38 / var(--tw-text-opacity)) !important;\n}\n.text-slate-50 {\n  --tw-text-opacity: 1 !important;\n  color: rgb(248 250 252 / var(--tw-text-opacity)) !important;\n}\n.text-white {\n  --tw-text-opacity: 1 !important;\n  color: rgb(255 255 255 / var(--tw-text-opacity)) !important;\n}\n.text-white\\/50 {\n  color: rgb(255 255 255 / 0.5) !important;\n}\n.underline {\n  text-decoration-line: underline !important;\n}\n.line-through {\n  text-decoration-line: line-through !important;\n}\n.no-underline {\n  text-decoration-line: none !important;\n}\n.opacity-25 {\n  opacity: 0.25 !important;\n}\n.opacity-30 {\n  opacity: 0.3 !important;\n}\n.opacity-35 {\n  opacity: 0.35 !important;\n}\n.opacity-50 {\n  opacity: 0.5 !important;\n}\n.shadow-inner {\n  --tw-shadow: inset 0 2px 4px 0 rgb(0 0 0 / 0.05) !important;\n  --tw-shadow-colored: inset 0 2px 4px 0 var(--tw-shadow-color) !important;\n  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow) !important;\n}\n.shadow-md {\n  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1) !important;\n  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color) !important;\n  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow) !important;\n}\n.shadow-none {\n  --tw-shadow: 0 0 #0000 !important;\n  --tw-shadow-colored: 0 0 #0000 !important;\n  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow) !important;\n}\n.outline-none {\n  outline: 2px solid transparent !important;\n  outline-offset: 2px !important;\n}\n.outline {\n  outline-style: solid !important;\n}\n.outline-0 {\n  outline-width: 0px !important;\n}\n.blur {\n  --tw-blur: blur(8px) !important;\n  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow) !important;\n}\n.filter {\n  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow) !important;\n}\n.transition {\n  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, -webkit-backdrop-filter !important;\n  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter !important;\n  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter, -webkit-backdrop-filter !important;\n  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1) !important;\n  transition-duration: 150ms !important;\n}\n.transition-all {\n  transition-property: all !important;\n  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1) !important;\n  transition-duration: 150ms !important;\n}\n.transition-transform {\n  transition-property: transform !important;\n  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1) !important;\n  transition-duration: 150ms !important;\n}\n.ease-out {\n  transition-timing-function: cubic-bezier(0, 0, 0.2, 1) !important;\n}\nlabel {\n    margin: 0 !important;\n    letter-spacing: unset !important;\n    font-weight: unset !important;\n    color: unset !important;\n    text-transform: unset !important;\n    width: auto !important;\n  }\nbutton:not(.border) {\n    border: 0 !important;\n  }\nbutton:hover {\n    background-image: none !important;\n  }\n.animated-number > div {\n    justify-content: flex-end !important;\n  }\n.claim-button,\n  .claim-button:hover {\n    background: linear-gradient(0deg, #0a0a0a 0%, #404040 100%) !important;\n  }\n.animate-button {\n    transition: box-shadow 0.3s ease !important;\n  }\n.animate-button::before {\n    content: '' !important;\n    position: absolute !important;\n    top: var(--y) !important;\n    left: var(--x) !important;\n    transform: translate(-50%, -50%) !important;\n    width: 100px !important;\n    height: 100px !important;\n    border-radius: 50% !important;\n    background-color: var(--hover-background) !important;\n    filter: blur(30px) !important;\n    transition: opacity 0.3s ease !important;\n    pointer-events: none !important;\n    opacity: 0.2 !important;\n  }\nbody .animate-button::before {\n    filter: blur(20px) !important;\n  }\n.animate-button:hover::before {\n    opacity: 1 !important;\n  }\nbody .animate-tier::before {\n    top: 0 !important;\n    left: 0 !important;\n    transform: translate(var(--x), var(--y)) !important;\n    opacity: 1 !important;\n    transition: transform 1s ease !important;\n    width: 200px !important;\n    height: 200px !important;\n  }\n.show-html a {\n    text-decoration: underline !important;\n  }\n.button-border {\n    border: 1px solid #e5e7eb !important;\n  }\n.transparent-icon path {\n    fill: white !important;\n  }\n.learn-more-modal-title {\n  font-size: 1.25rem;\n  line-height: 1.75rem;\n  font-weight: 600;\n  --tw-text-opacity: 1;\n  color: rgb(0 0 0 / var(--tw-text-opacity));\n}\n.\\!\\[clip\\:rect\\(0\\2c 0\\2c 0\\2c 0\\)\\] {\n  clip: rect(0,0,0,0) !important;\n}\n@font-face {\n  font-family: 'ABCDiatype-Regular';\n  font-display: swap;\n  src: url('https://cdn.coinlist.co/fonts/ABCDiatype/ABCDiatype-Regular.woff2')\n    format('woff2');\n}\n@font-face {\n  font-family: 'ABCDiatype-Bold';\n  font-display: swap;\n  src: url('https://cdn.coinlist.co/fonts/ABCDiatype/ABCDiatype-Bold.woff2')\n    format('woff2');\n}\n.animate-button {\n  --hover-background: rgba(255, 255, 255, 0.2);\n}\n.ticker-digit {\n  text-align: center;\n}\n.placeholder\\:text-black\\/\\[\\.38\\]::-moz-placeholder {\n  color: rgb(0 0 0 / .38) !important;\n}\n.placeholder\\:text-black\\/\\[\\.38\\]::placeholder {\n  color: rgb(0 0 0 / .38) !important;\n}\n.checked\\:border-0:checked {\n  border-width: 0px !important;\n}\n.checked\\:bg-black:checked {\n  --tw-bg-opacity: 1 !important;\n  background-color: rgb(0 0 0 / var(--tw-bg-opacity)) !important;\n}\n.hover\\:scale-\\[1\\.02\\]:hover {\n  --tw-scale-x: 1.02 !important;\n  --tw-scale-y: 1.02 !important;\n  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;\n}\n.hover\\:border-neutral-400:hover {\n  --tw-border-opacity: 1 !important;\n  border-color: rgb(163 163 163 / var(--tw-border-opacity)) !important;\n}\n.hover\\:bg-black:hover {\n  --tw-bg-opacity: 1 !important;\n  background-color: rgb(0 0 0 / var(--tw-bg-opacity)) !important;\n}\n.hover\\:bg-gray-100:hover {\n  --tw-bg-opacity: 1 !important;\n  background-color: rgb(243 244 246 / var(--tw-bg-opacity)) !important;\n}\n.hover\\:bg-green-50:hover {\n  --tw-bg-opacity: 1 !important;\n  background-color: rgb(240 253 244 / var(--tw-bg-opacity)) !important;\n}\n.hover\\:bg-neutral-300:hover {\n  --tw-bg-opacity: 1 !important;\n  background-color: rgb(212 212 212 / var(--tw-bg-opacity)) !important;\n}\n.hover\\:bg-offWhite:hover {\n  --tw-bg-opacity: 1 !important;\n  background-color: rgb(250 250 250 / var(--tw-bg-opacity)) !important;\n}\n.hover\\:bg-smokeWhite:hover {\n  --tw-bg-opacity: 1 !important;\n  background-color: rgb(240 240 240 / var(--tw-bg-opacity)) !important;\n}\n.hover\\:text-black:hover {\n  --tw-text-opacity: 1 !important;\n  color: rgb(0 0 0 / var(--tw-text-opacity)) !important;\n}\n.hover\\:text-green-700:hover {\n  --tw-text-opacity: 1 !important;\n  color: rgb(21 128 61 / var(--tw-text-opacity)) !important;\n}\n.hover\\:text-white:hover {\n  --tw-text-opacity: 1 !important;\n  color: rgb(255 255 255 / var(--tw-text-opacity)) !important;\n}\n.hover\\:underline:hover {\n  text-decoration-line: underline !important;\n}\n.hover\\:opacity-50:hover {\n  opacity: 0.5 !important;\n}\n.focus\\:border-black:focus {\n  --tw-border-opacity: 1 !important;\n  border-color: rgb(0 0 0 / var(--tw-border-opacity)) !important;\n}\n.focus\\:text-black:focus {\n  --tw-text-opacity: 1 !important;\n  color: rgb(0 0 0 / var(--tw-text-opacity)) !important;\n}\n.focus\\:text-white:focus {\n  --tw-text-opacity: 1 !important;\n  color: rgb(255 255 255 / var(--tw-text-opacity)) !important;\n}\n.peer:checked ~ .peer-checked\\:block {\n  display: block !important;\n}\n@media (prefers-reduced-motion: reduce) {\n\n  @keyframes spin {\n\n    to {\n      transform: rotate(360deg);\n    }\n  }\n\n  .motion-reduce\\:animate-\\[spin_1\\.5s_linear_infinite\\] {\n    animation: spin 1.5s linear infinite !important;\n  }\n}\n@media (min-width: 350px) {\n\n  .min-\\[350px\\]\\:grid-cols-3 {\n    grid-template-columns: repeat(3, minmax(0, 1fr)) !important;\n  }\n}\n@media (min-width: 640px) {\n\n  .sm\\:col-span-2 {\n    grid-column: span 2 / span 2 !important;\n  }\n\n  .sm\\:block {\n    display: block !important;\n  }\n\n  .sm\\:h-auto {\n    height: auto !important;\n  }\n\n  .sm\\:w-130 {\n    width: 35rem !important;\n  }\n\n  .sm\\:w-\\[46\\%\\] {\n    width: 46% !important;\n  }\n\n  .sm\\:w-\\[525px\\] {\n    width: 525px !important;\n  }\n\n  .sm\\:w-\\[90px\\] {\n    width: 90px !important;\n  }\n\n  .sm\\:grid-cols-2 {\n    grid-template-columns: repeat(2, minmax(0, 1fr)) !important;\n  }\n\n  .sm\\:grid-cols-3 {\n    grid-template-columns: repeat(3, minmax(0, 1fr)) !important;\n  }\n\n  .sm\\:flex-row {\n    flex-direction: row !important;\n  }\n\n  .sm\\:flex-col {\n    flex-direction: column !important;\n  }\n\n  .sm\\:gap-4 {\n    gap: 1rem !important;\n  }\n\n  .sm\\:rounded-3xl {\n    border-radius: 1.5rem !important;\n  }\n\n  .sm\\:bg-cover {\n    background-size: cover !important;\n  }\n\n  .sm\\:px-8 {\n    padding-left: 2rem !important;\n    padding-right: 2rem !important;\n  }\n\n  .sm\\:py-8 {\n    padding-top: 2rem !important;\n    padding-bottom: 2rem !important;\n  }\n\n  .sm\\:pb-7 {\n    padding-bottom: 1.75rem !important;\n  }\n\n  .sm\\:pt-11 {\n    padding-top: 2.75rem !important;\n  }\n\n  .sm\\:pt-6 {\n    padding-top: 1.5rem !important;\n  }\n\n  .sm\\:text-left {\n    text-align: left !important;\n  }\n}\n@media (min-width: 768px) {\n\n  .md\\:block {\n    display: block !important;\n  }\n\n  .md\\:hidden {\n    display: none !important;\n  }\n\n  .md\\:min-w-\\[500px\\] {\n    min-width: 500px !important;\n  }\n\n  .md\\:grid-cols-3 {\n    grid-template-columns: repeat(3, minmax(0, 1fr)) !important;\n  }\n}\n@media (min-width: 1024px) {\n\n  .lg\\:flex {\n    display: flex !important;\n  }\n\n  .lg\\:hidden {\n    display: none !important;\n  }\n\n  .lg\\:w-1\\/4 {\n    width: 25% !important;\n  }\n\n  .lg\\:max-w-xs {\n    max-width: 20rem !important;\n  }\n\n  .lg\\:grid-cols-2 {\n    grid-template-columns: repeat(2, minmax(0, 1fr)) !important;\n  }\n\n  .lg\\:grid-cols-4 {\n    grid-template-columns: repeat(4, minmax(0, 1fr)) !important;\n  }\n\n  .lg\\:flex-row {\n    flex-direction: row !important;\n  }\n\n  .lg\\:justify-end {\n    justify-content: flex-end !important;\n  }\n\n  .lg\\:gap-4 {\n    gap: 1rem !important;\n  }\n}\n@media (min-width: 1280px) {\n\n  .xl\\:w-1\\/4 {\n    width: 25% !important;\n  }\n\n  .xl\\:max-w-xs {\n    max-width: 20rem !important;\n  }\n\n  .xl\\:flex-row {\n    flex-direction: row !important;\n  }\n}\n.ticker-view {\n  height: auto;\n  margin: auto;\n  display: flex;\n  flex-direction: row-reverse;\n  overflow: hidden;\n  position: relative;\n}\n\n.number-placeholder {\n  visibility: hidden;\n}\n\n.ticker-column-container {\n  position: relative;\n}\n\n.ticker-column {\n  position: absolute;\n  height: 1000%;\n  bottom: 0;\n}\n\n.ticker-digit {\n  width: auto;\n  height: 10%;\n}\n\n.ticker-column.increase {\n  animation: pulseIncrement 500ms cubic-bezier(0.4, 0, 0.6, 1) 1;\n}\n\n.ticker-column.decrease {\n  animation: pulseDecrement 500ms cubic-bezier(0.4, 0, 0.6, 1) 1;\n}\n\n@keyframes pulseIncrement {\n  0%, 100% { color: inherit; }\n  50% { color: var(--increment-color) }\n}\n\n@keyframes pulseDecrement {\n  0%, 100% { color: inherit; }\n  50% { color: var(--decrement-color) }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
